import React from "react"
import {Button} from 'primereact/button';
import {FormSectionElements, FormSections, FormSubSections, ProgramContainer, CustomHeaderMenuItem} from "../entities/formTemplateDataType";
import {InputText} from "primereact/inputtext";
import {SelectButton} from "primereact/selectbutton";
import {Panel} from "primereact/panel";
import {InputTextarea} from "primereact/inputtextarea";
import {Dropdown} from "primereact/dropdown";
import {MultiSelect} from "primereact/multiselect";
import {authticationMethodList, elementTypeList, EnvBaseUrl, FR_SUFFIX, TOKEN_TYPE,HOSTS, menuOptions} from "../entities/Constants";
import {TableComponent} from "./subComponent/TableComponent";
import {MoreButtonComponent} from "./subComponent/MoreButtonComponent";
import URLUtils from "../utilities/URLUtils";
import axios from "axios";
import {Toast} from 'primereact/toast';
import {DialogForAPIComponent} from "./subComponent/DialogforAPIComponent";
import {SplitButton} from "primereact/splitbutton";
import {FileUpload} from "primereact/fileupload";
import {ConfirmDialog} from 'primereact/confirmdialog';
import {DialogForSectionPropertyComponent} from "./subComponent/DialogForSectionPropertyComponent";
import {Editor} from "primereact/editor";
import 'primereact/resources/primereact.css'; // core css
import 'primeicons/primeicons.css'; // icons
import 'primeflex/primeflex.css'; // css utility
import {PdfUtils} from '../utilities/PdfUtils';
import {Checkbox} from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import {DropdownDesignComponent} from "./subComponent/DropdownDesignComponent";
import {GroupDropdownDesignComponent} from "./subComponent/GroupDropdownDesignComponent";
import {DropdownWithRichTextDesignComponent} from "./subComponent/DropdownWithRichTextDesignComponent";

import {InputNumber} from 'primereact/inputnumber';
import StarRating from "../runtimeComponent/subComponent/StarRatingComponent";
import QRCodeComponent from "../runtimeComponent/subComponent/QRCodeComponent";
import {DialogForHelpComponent} from "./subComponent/DialogForHelpComponent";
import AccordionsDesignComponent from "./subComponent/AccordionsDesignComponent";
import {AccordionData} from "src/commonComponent/AccordionsComponent";
import {findDependency, getRootComponent} from "../utilities/ElementUtils";
import {TableMenuDesignComponent} from "./subComponent/TableMenuDesignComponent";
import {TableSummaryDesignComponent} from "./subComponent/TableSummaryDesignComponent";
import SessionStorageService from "../services/SessionStorageService";
import LocalStorageService from "../services/SessionStorageService";
import {deepClone, parseJson, stringifyJson} from "../utilities/JsonUtils";
import AzureUsersLookUpComponent from "./subComponent/AzureUsersLookUpComponent";
import Utils from "../utilities/Utils";
import {DialogForSubmitComponent} from "./subComponent/DialogForSubmitComponent";
import {DialogForSubSectionPropertyComponent} from "./subComponent/DialogForSubSectionPropertyComponent";
import {SearchAutocompleteDesignComponent} from "./subComponent/SearchAutocompleteDesignComponent";
import {DialogForEmailContents} from "./subComponent/DialogForEmailContents";
import {DialogForInboxContents} from "./subComponent/DialogForInboxContents";
import {DialogForPageRedirectComponent} from "./subComponent/DialogForPageRedirectComponent";
import {ErrorDescriptionDesignComponent} from "./subComponent/ErrorDescriptionDesignComponent";
import GlobalKeyValuePairsComponent from "./subComponent/GlobalKeyValuePairsComponent";
import {analyzeScreenshots, populateFormFromAnalysis} from "../services/ClaudeScreenshotService";
import {ProgressBar} from "primereact/progressbar";

interface Props {
    programContainer: ProgramContainer;
    isEng: boolean;
    dialogVisible: boolean;
    callback: (programContainer: ProgramContainer) => void;
    callBackLang: (isEng: boolean) => void;
    callbackSave?: () => void;
}
interface State {
    templateList;
    dialogVisible: boolean;
    apiDialogVisible: boolean[];
    panelCollapsed: boolean[];
    confirmCallback?: () => void;
    confirmVisible: boolean;
    sectionDialogVisible: boolean[];
    pageRedirectionDialogVisible: boolean;
    helpDialogVisible: boolean;
    emailDialogVisible: boolean;
    inboxDialogVisible: boolean;
    submitDialogVisible: boolean;
    subSectionDialogVisible: boolean[][];
    sectionImportDialogVisible: boolean[];
    customHeaderMenuDialogVisible: boolean;
    customHeaderMenuEditIndex: number | null;
    customHeaderMenuDraft: CustomHeaderMenuItem;

    isButtonActive: boolean;
    panelHeaderCollapsed: boolean;
    screenshotDialogVisible: boolean;
    screenshotUploading: boolean;
    screenshotError: string | null;
    pastedScreenshots: File[];
    screenshotAdditionalPrompt: string;
}

const hiddenAttributesByStepper = {
  hiddenStepper: [
    "emailAPI",
    "TopNavigation",
    "CheckboxValueYN",
    "ForSiebel",
    "HasSaveDraftButton",
    "NoClearButton",
  ],
};

function showHeaderAttribute(attributeName: string, stepperType: string) {
  return !hiddenAttributesByStepper[stepperType]?.includes(attributeName);
}


export class FormDesignComponent extends React.Component<Props, State> {
    growl: Toast;
    attachment: {};
    line1;
    ref;
    customSummaryHeaderEditor;
    customApplicationHeaderEditor;
    displayFormLsit = [
        { description: 'Stepper', value: 'stepper' },
        { description: 'Stepper without step title', value: 'NoIndicatorStepper' },
        { description: 'Stepper with step title', value: 'hiddenStepperWithSectionTitle' },
        { description: 'Hidden stepper', value: 'hiddenStepper' },
        { description: 'Progress bar as stepper', value: 'progressBarStepper' },
        { description: 'Panel', value: 'panel' },
    ];
    HeaderList = [
        { description: 'Application', value: 'Application' },
        { description: 'ServiceOntario', value: 'ServiceOntario' },
        { description: 'Ontario.ca', value: 'Ontario' },
        { description: 'Labour', value: 'Labour' },
        { description: 'MCCSS', value: 'MCCSS' },
    ];
    FooterList = [
        { description: 'Simple', value: 'Simple' },
        { description: 'CXP', value: 'CXP' },
        { description: 'Ministry of Labour', value: 'MOL' },
        { description: 'BXP', value: 'BXP' },
        { description: 'EHS Partner Portal', value: 'EHSPartnerPortal' },
    ];
    constructor(props: Props) {

        super(props);

        this.state = {
            templateList: [],
            dialogVisible: false,
            apiDialogVisible: [],
            panelCollapsed: [],
            confirmVisible: false,
            sectionDialogVisible: [],
            pageRedirectionDialogVisible: false,
            helpDialogVisible: false,
            submitDialogVisible: false,
            emailDialogVisible: false,
            inboxDialogVisible: false,
            subSectionDialogVisible: [],
            sectionImportDialogVisible: [],
            customHeaderMenuDialogVisible: false,
            customHeaderMenuEditIndex: null,
            customHeaderMenuDraft: {},
            isButtonActive: true,
            panelHeaderCollapsed: false,
            screenshotDialogVisible: false,
            screenshotUploading: false,
            screenshotError: null,
            pastedScreenshots: [],
            screenshotAdditionalPrompt: ''
        }

    }

    private isCurrentUserCreator = (): boolean => {
        try {
            const uid = (LocalStorageService.getUserId() || '').toLowerCase();
            const created = this.props.programContainer?.createdById?.toLowerCase()
                || this.props.programContainer?.createdBy?.toLowerCase();
            return Boolean(uid && created && uid === created);
        } catch {
            return false;
        }
    }

    showConfirmation = (callback?: () => void) => {
        this.setState({
            confirmVisible: true,
            confirmCallback: callback,
        });
    };

    confirmRemove = (confirmed: boolean) => {
        if (confirmed) {
            const callback = this.state.confirmCallback;
            if (callback) {
                callback();
            }
        }

        this.setState({
            confirmVisible: false,
        });
    };

    componentDidMount(): void {

        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        const headers = {
            'Authorization': `Bearer ${token}`
        }

        let api = URLUtils.concatUrls("data/admin/all-template");
        axios.get(api, { headers: headers })
            .then((result) => {
                const data = Array.isArray(result.data)
                    ? result.data
                    : Array.isArray(result.data?.data)
                        ? result.data.data
                        : [];

                const templateList = data.map(p => ({
                    code: p.attachment,
                    description: `${p.categoryName} (${p.userName})`
                }));

                this.setState({ templateList });
            })
            .catch(error => {
                console.error('Error fetching templates:', error);
            });

        // Auto-enable Exit Popup for Labour and ServiceOntario header types by default
        if (this.props.programContainer && (this.props.programContainer.HeaderType === "Labour" || this.props.programContainer.HeaderType === "ServiceOntario") && this.props.programContainer.EnableExitPopup !== "Y") {
            this.props.programContainer.EnableExitPopup = "Y";
            this.props.programContainer.ExitPopupTitle = this.props.programContainer.ExitPopupTitle || "Are you sure you want to exit?";
            this.props.programContainer.ExitPopupMessage = this.props.programContainer.ExitPopupMessage || "If you leave this page your progress will not be saved.";
            this.props.programContainer.ExitPopupStayButtonLabel = this.props.programContainer.ExitPopupStayButtonLabel || "Stay on this page";
            this.props.programContainer.ExitPopupExitButtonLabel = this.props.programContainer.ExitPopupExitButtonLabel || "Exit without saving";
            this.props.callback(this.props.programContainer);
        }
    }


    generateForm = () => {
        const options = ['English', 'French'];
        let htmlString = [];
        let panelArray = [];


        let formSectionsList = this.props.programContainer.ListOfFormSections;

        const divStyle = {
            backgroundColor: '#d3d3d3', // Specify the desired background color
            padding: '10px',
            marginBottom: '10px',
        };

        this.props.programContainer.ListOfFormSections.forEach(ele => {
            panelArray[ele.Id] = true;
        })
        const isCreator = this.isCurrentUserCreator();
        const hostedIsMissing = !this.props.programContainer.Hosted;
        const appIdMissing = Utils.isNullOrEmpty(this.props.programContainer.CategoryId);
        const appNameMissing = Utils.isNullOrEmpty(this.props.isEng ? this.props.programContainer.Name : this.props.programContainer.NameFRA);

        htmlString.push(
            <div key={"form_"} style={{ width: '100%' }} >
                <div>
                    <div style={{ display: this.props.programContainer.EnglishOnly ? "none" : 'flex', justifyContent: 'end', marginBottom: '20px' }} >
                        {/* @ts-ignore */}
                        <SelectButton
                            value={this.props.isEng ? 'English' : 'French'}
                            onChange={(e) => this.props.callBackLang(e.value == 'English')} options={options} />
                    </div>

                    <div style={{ display: 'flex', marginBottom: '20px', marginTop: '10px', alignItems: 'center', gap: '5px' }} >
                        {/* @ts-ignore */}
                        <Button
                            label="Expand"
                            icon="pi pi-angle-double-down"
                            className={this.state.isButtonActive ? "p-button-text" : "p-button-outlined p-button-secondary"}
                            style={this.state.isButtonActive ? {} : { border: '1px solid grey', color: 'grey' }}
                            onClick={() => {
                                const updatedPanelArray = panelArray.map(() => false); // Set all elements to false (expanded)
                                this.setState({ 
                                    panelCollapsed: updatedPanelArray, 
                                    panelHeaderCollapsed: false,
                                    isButtonActive: true 
                                });
                            }} />
                        {/* @ts-ignore */}
                        <Button
                            label="Collapse"
                            icon="pi pi-angle-double-up"
                            className={this.state.isButtonActive ? "p-button-outlined p-button-secondary" : "p-button-text"}
                            style={this.state.isButtonActive
                                ? { border: '1px solid grey', color: 'grey' }
                                : {}}
                            onClick={() => {
                                const updatedPanelArray = panelArray.map(() => true); // Set all elements to true (collapsed)
                                this.setState({ 
                                    panelCollapsed: updatedPanelArray, 
                                    panelHeaderCollapsed: true,
                                    isButtonActive: false 
                                });
                            }} />
                        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '12px' }}>
                            {/* @ts-ignore */}
                            <Button
                                label="Upload Screenshots"
                                icon="pi pi-sparkles"
                                className="p-button-info"
                                onClick={() => this.setState({ screenshotDialogVisible: true, screenshotError: null })}
                                disabled={this.state.screenshotUploading}
                            />
                            {this.state.screenshotUploading && (
                                <span style={{ color: '#666', fontSize: '0.9em' }}>Analyzing screenshots with AI...</span>
                            )}
                        </div>
                    </div>
                    {this.state.screenshotUploading && (
                        <ProgressBar mode="indeterminate" style={{ height: '6px', marginBottom: '8px' }} />
                    )}
                    {this.state.screenshotError && (
                        <div style={{ color: '#c62828', backgroundColor: '#fce4ec', padding: '8px 12px', borderRadius: '4px', marginBottom: '8px' }}>
                            {this.state.screenshotError}
                        </div>
                    )}
                    {/* @ts-ignore */}
                    <Panel header='Form Header' toggleable collapsed={this.state.panelHeaderCollapsed} onToggle={(e) => {
                        // let panelArray = this.state.panelCollapsed;
                        // panelArray['Header'] = e.value;
                        this.setState({
                            panelHeaderCollapsed: e.value
                        })
                    }}>
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Application ID <span style={{ color: 'red' }}>*</span>:
                            </div>
                            <InputText value={this.props.programContainer.CategoryId || ''} keyfilter={/^\S+$/} className={`ontario-input ${appIdMissing ? 'p-invalid' : ''}`} title="Category ID" required onChange={(e) => {
                                this.props.programContainer.CategoryId = e.target.value;
                                this.props.callback(this.props.programContainer);
                            }} />
                            {appIdMissing && (
                                <small style={{ color: 'red', marginLeft: '8px' }}>Required</small>
                            )}
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Application Name <span style={{ color: 'red' }}>*</span>:
                            </div>

                            <InputText value={(this.props.isEng ? this.props.programContainer.Name : this.props.programContainer.NameFRA) || ''}
                                className={`ontario-input ${appNameMissing ? 'p-invalid' : ''}`} required onChange={(e) => {

                                    if (this.props.isEng) {
                                        if (Utils.willDefaultFR(this.props.programContainer.Name, this.props.programContainer.NameFRA)) {
                                            this.props.programContainer.NameFRA = Utils.isNullOrEmpty(e.target.value) ? '' : e.target.value + FR_SUFFIX;
                                        }
                                        this.props.programContainer.Name = e.target.value;
                                    }
                                    else {
                                        this.props.programContainer.NameFRA = e.target.value;
                                    }

                                    this.props.callback(this.props.programContainer);
                                    e.target.focus();
                                }} />
                            {appNameMissing && (
                                <small style={{ color: 'red', marginLeft: '8px' }}>Required</small>
                            )}
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Application title:
                            </div>
                            <InputText value={(this.props.isEng ? this.props.programContainer.AppTitle?.en : this.props.programContainer.AppTitle?.fr) || ''}
                                className='ontario-input' onChange={(e) => {
                                    if (this.props.isEng) {
                                        if (Utils.willDefaultFR(this.props.programContainer.AppTitle?.en, this.props.programContainer.AppTitle?.fr)) {
                                            this.props.programContainer.AppTitle = { en: e.target.value, fr: Utils.isNullOrEmpty(e.target.value) ? '' : e.target.value + FR_SUFFIX };
                                        }
                                        this.props.programContainer.AppTitle = { ...this.props.programContainer.AppTitle ?? {}, en: e.target.value };
                                    } else {
                                        this.props.programContainer.AppTitle = { ...this.props.programContainer.AppTitle ?? {}, fr: e.target.value };
                                    }

                                    this.props.callback(this.props.programContainer);
                                    e.target.focus();
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Host: <span style={{ color: 'red' }}>*</span>:
                            </div>
                            {/* @ts-ignore */}
                            <Dropdown
                                className={hostedIsMissing ? "p-invalid" : ""}
                                placeholder="App is going to be hosted in"
                                options={HOSTS}
                                value={this.props.programContainer.Hosted}
                                required
                                onChange={(e) => {
                                    this.props.programContainer.Hosted = e.value;
                                    this.props.callback(this.props.programContainer);
                                }}></Dropdown>
                            {hostedIsMissing && (
                                <small style={{ color: 'red', marginLeft: '8px' }}>Required</small>
                            )}
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Authentication Method:
                            </div>
                            {/* @ts-ignore */}
                            <Dropdown
                                // className="p-dropdown"
                                placeholder="Select authentication method"
                                options={authticationMethodList}
                                optionLabel="label"
                                optionValue="val"
                                value={this.props.programContainer.AuthRequired}
                                onChange={(e) => {
                                    this.props.programContainer.AuthRequired = e.value;
                                    // Initialize BpsConfig when BPS is selected
                                    if (e.value === 'bps' && !this.props.programContainer.BpsConfig) {
                                        this.props.programContainer.BpsConfig = {
                                            domain: '',
                                            clientId: '',
                                            tokenEndpoint: '',
                                        };
                                    }
                                    this.props.callback(this.props.programContainer);
                                }}></Dropdown>
                        </div>

                        {/* BPS Configuration Fields - shown when BPS authentication is selected */}
                        {this.props.programContainer.AuthRequired === 'bps' && (
                            <div style={{
                                marginTop: '10px',
                                marginLeft: '14%',
                                padding: '10px',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                backgroundColor: '#f9f9f9'
                            }}>
                                <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>BPS Configuration</div>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    <div style={{ width: '120px' }}>Domain:</div>
                                    <InputText
                                        value={this.props.programContainer.BpsConfig?.domain || ''}
                                        className='ontario-input'
                                        style={{ width: '300px' }}
                                        onChange={(e) => {
                                            if (!this.props.programContainer.BpsConfig) {
                                                this.props.programContainer.BpsConfig = { domain: '', clientId: '', tokenEndpoint: '' };
                                            }
                                            this.props.programContainer.BpsConfig.domain = e.target.value;
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    <div style={{ width: '120px' }}>Client ID:</div>
                                    <InputText
                                        value={this.props.programContainer.BpsConfig?.clientId || ''}
                                        className='ontario-input'
                                        style={{ width: '300px' }}
                                        onChange={(e) => {
                                            if (!this.props.programContainer.BpsConfig) {
                                                this.props.programContainer.BpsConfig = { domain: '', clientId: '', tokenEndpoint: '' };
                                            }
                                            this.props.programContainer.BpsConfig.clientId = e.target.value;
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    <div style={{ width: '120px' }}>Token Endpoint:</div>
                                    <InputText
                                        value={this.props.programContainer.BpsConfig?.tokenEndpoint || ''}
                                        className='ontario-input'
                                        style={{ width: '300px' }}
                                        onChange={(e) => {
                                            if (!this.props.programContainer.BpsConfig) {
                                                this.props.programContainer.BpsConfig = { domain: '', clientId: '', tokenEndpoint: '' };
                                            }
                                            this.props.programContainer.BpsConfig.tokenEndpoint = e.target.value;
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    <div style={{ width: '120px' }}>Refresh Endpoint:</div>
                                    <InputText
                                        value={this.props.programContainer.BpsConfig?.refreshEndpoint || ''}
                                        className='ontario-input'
                                        style={{ width: '300px' }}
                                        onChange={(e) => {
                                            if (!this.props.programContainer.BpsConfig) {
                                                this.props.programContainer.BpsConfig = { domain: '', clientId: '', tokenEndpoint: '' };
                                            }
                                            this.props.programContainer.BpsConfig.refreshEndpoint = e.target.value;
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    <div style={{ width: '120px' }}>Redirect Uri</div>
                                    <InputText
                                        value={this.props.programContainer.BpsConfig?.logoutEndpoint || ''}
                                        className='ontario-input'
                                        style={{ width: '300px' }}
                                        onChange={(e) => {
                                            if (!this.props.programContainer.BpsConfig) {
                                                this.props.programContainer.BpsConfig = { domain: '', clientId: '', tokenEndpoint: '' };
                                            }
                                            this.props.programContainer.BpsConfig.logoutEndpoint = e.target.value;
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                </div>

                            </div>
                        )}

                        {/* Entra ID Configuration Fields - shown when Entra ID authentication is selected */}
                        {this.props.programContainer.AuthRequired === 'ad' && (
                            <div style={{
                                marginTop: '10px',
                                marginLeft: '14%',
                                padding: '10px',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                backgroundColor: '#f9f9f9'
                            }}>
                                <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>Entra ID Configuration</div>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    <div style={{ width: '120px' }}>Scope:</div>
                                    <InputText
                                        value={this.props.programContainer.Scopes || ''}
                                        className='ontario-input'
                                        style={{ width: '500px' }}
                                        onChange={(e) => {
                                            this.props.programContainer.Scopes = e.target.value;
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    <div style={{ width: '120px' }}>UI Azure Registration:</div>
                                    <InputText
                                        value={this.props.programContainer.UiAzureRegistration || ''}
                                        className='ontario-input'
                                        style={{ width: '500px' }}
                                        onChange={(e) => {
                                            this.props.programContainer.UiAzureRegistration = e.target.value;
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    <div style={{ width: '120px' }}>UI Azure Tenant ID:</div>
                                    <InputText
                                        value={this.props.programContainer.UiAzureTenantId || ''}
                                        className='ontario-input'
                                        style={{ width: '500px' }}
                                        onChange={(e) => {
                                            this.props.programContainer.UiAzureTenantId = e.target.value;
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                </div>
                            </div>
                        )}

                        <div style={{ width: '100%', marginTop: '5px' }}>
                            <div style={{ width: '14%', marginBottom: '6px' }}>Header Menu Config:</div>
                            <div style={{ width: '86%', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px' }}>
                                {/* @ts-ignore */}
                                <MultiSelect
                                    value={(this.props.programContainer.HeaderMenuConfig || '')
                                        .split(',')
                                        .map(id => id.trim())
                                        .filter(id => id.length > 0)}
                                    options={menuOptions}
                                    onChange={(e) => {
                                        this.props.programContainer.HeaderMenuConfig = (e.value || []).join(',');
                                        this.props.callback(this.props.programContainer);
                                    }}
                                    optionLabel="title-en"
                                    optionValue="id"
                                    placeholder="Select menu items"
                                    display="chip"
                                    style={{ flex: '1', minWidth: '200px' }}
                                />
                                {(this.props.programContainer.CustomHeaderMenuItems || []).map((item: CustomHeaderMenuItem, idx: number) => (
                                    <span
                                        key={idx}
                                        style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '4px',
                                            padding: '4px 10px',
                                            borderRadius: '16px',
                                            backgroundColor: '#e0e0e0',
                                            fontSize: '13px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => this.setState({
                                            customHeaderMenuDialogVisible: true,
                                            customHeaderMenuEditIndex: idx,
                                            customHeaderMenuDraft: { ...item },
                                        })}
                                    >
                                        {item.TitleEN || item.TitleFRA || 'Menu option'}
                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                const list = [...(this.props.programContainer.CustomHeaderMenuItems || [])];
                                                list.splice(idx, 1);
                                                this.props.programContainer.CustomHeaderMenuItems = list.length ? list : undefined;
                                                this.props.callback(this.props.programContainer);
                                            }}
                                            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0 2px', lineHeight: 1 }}
                                            aria-label="Remove"
                                        >
                                            ×
                                        </button>
                                    </span>
                                ))}
                                <Button label="Add" icon="pi pi-plus" className="p-button-outlined p-button-sm" onClick={() => {
                                    this.setState({
                                        customHeaderMenuDialogVisible: true,
                                        customHeaderMenuEditIndex: null,
                                        customHeaderMenuDraft: { TitleEN: '', TitleFRA: '', LinkEN: '', LinkFRA: '', StepperScript: '' },
                                    });
                                }} />
                            </div>
                            <Dialog
                                header="Custom menu option"
                                visible={this.state.customHeaderMenuDialogVisible}
                                style={{ width: '420px' }}
                                onHide={() => this.setState({ customHeaderMenuDialogVisible: false })}
                                footer={
                                    <>
                                        <Button label="Cancel" className="p-button-text" onClick={() => this.setState({ customHeaderMenuDialogVisible: false })} />
                                        <Button label="Save" onClick={() => {
                                            const list = [...(this.props.programContainer.CustomHeaderMenuItems || [])];
                                            const draft = this.state.customHeaderMenuDraft;
                                            if (this.state.customHeaderMenuEditIndex === null) {
                                                list.push({ ...draft });
                                            } else {
                                                list[this.state.customHeaderMenuEditIndex] = { ...draft };
                                            }
                                            this.props.programContainer.CustomHeaderMenuItems = list;
                                            this.props.callback(this.props.programContainer);
                                            this.setState({ customHeaderMenuDialogVisible: false });
                                        }} />
                                    </>
                                }
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px' }}>Title (EN)</label>
                                        <InputText value={this.state.customHeaderMenuDraft?.TitleEN || ''} className="ontario-input" style={{ width: '100%' }} onChange={(e) => this.setState({ customHeaderMenuDraft: { ...this.state.customHeaderMenuDraft, TitleEN: e.target.value } })} placeholder="Menu label (English)" />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px' }}>Title (FR)</label>
                                        <InputText value={this.state.customHeaderMenuDraft?.TitleFRA || ''} className="ontario-input" style={{ width: '100%' }} onChange={(e) => this.setState({ customHeaderMenuDraft: { ...this.state.customHeaderMenuDraft, TitleFRA: e.target.value } })} placeholder="Menu label (French)" />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px' }}>Link (EN)</label>
                                        <InputText value={this.state.customHeaderMenuDraft?.LinkEN || ''} className="ontario-input" style={{ width: '100%' }} onChange={(e) => this.setState({ customHeaderMenuDraft: { ...this.state.customHeaderMenuDraft, LinkEN: e.target.value } })} placeholder="https://..." />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px' }}>Link (FR)</label>
                                        <InputText value={this.state.customHeaderMenuDraft?.LinkFRA || ''} className="ontario-input" style={{ width: '100%' }} onChange={(e) => this.setState({ customHeaderMenuDraft: { ...this.state.customHeaderMenuDraft, LinkFRA: e.target.value } })} placeholder="https://..." />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px' }}>Stepper script (optional)</label>
                                        <InputTextarea value={this.state.customHeaderMenuDraft?.StepperScript || ''} className="ontario-input" style={{ width: '100%', minHeight: '60px' }} onChange={(e) => this.setState({ customHeaderMenuDraft: { ...this.state.customHeaderMenuDraft, StepperScript: e.target.value } })} placeholder="(callbackStepIndex) => { }" rows={2} />
                                    </div>
                                </div>
                            </Dialog>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Enable Application Header Menu:
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {/* @ts-ignore */}
                                <Checkbox
                                    checked={this.props.programContainer.ForceApplicationHeaderMenu === true}
                                    className="p-checkbox"
                                    title="Enable Application Header Menu"
                                    onChange={e => {
                                        this.props.programContainer.ForceApplicationHeaderMenu = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }}
                                />
                            </div>
                        </div>

                        {showHeaderAttribute("ForSiebel", this.props.programContainer.displayForm) && (
                            <div style={{display:"flex",alignItems:"center",marginTop:"5px"}}>
                                <div style={{width:"14%"}}>For Siebel Embedded:</div>
                                <div style={{alignItems:"center",marginTop:"5px"}}>
                                    {/* @ts-ignore */}
                                    <Checkbox
                                        checked={this.props.programContainer.ForSiebel=="Y"}
                                        value={this.props.programContainer.ForSiebel}
                                        className="p-checkbox"
                                        title="For Siebel"
                                        onChange={e=>{
                                            this.props.programContainer.ForSiebel=e.checked?"Y":"N";
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                </div>
                                <div style={{
                                    display:this.props.programContainer.ForSiebel=="Y"?"flex":"none",
                                    marginLeft:"10px"
                                }}>
                                    Int Object Name:
                                </div>
                                <div style={{width:"auto"}}>
                                    <InputText
                                        style={{
                                            display:this.props.programContainer.ForSiebel=="Y"?"flex":"none",
                                            marginLeft:"10px",
                                            width:"100%"
                                        }}
                                        value={this.props.programContainer.IntObjectName}
                                        className="ontario-input"
                                        title="Int Object Name"
                                        onChange={e=>{
                                            this.props.programContainer.IntObjectName=e.target.value;
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                </div>
                            </div>
                        )}


                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                API Base Path:
                            </div>

                            <InputText value={this.props.programContainer.APIBasePath || ''} className='ontario-input' title="API Base Path"
                                onChange={(e) => {
                                    this.props.programContainer.APIBasePath = e.target.value;
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Initial Data API:
                            </div>

                            <InputText
                                value={this.props.programContainer.InitialDataAPI || ''}
                                className='ontario-input'
                                title="Initial Data API"
                                onChange={(e) => {
                                    this.props.programContainer.InitialDataAPI = e.target.value;
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>


                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Get API:
                            </div>

                            <InputText value={this.props.programContainer.GetAPI || ''} className='ontario-input' title="Get API"
                                onChange={(e) => {
                                    this.props.programContainer.GetAPI = e.target.value;
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Create API:
                            </div>

                            <InputText value={this.props.programContainer.CreateAPI || ''} className='ontario-input' title="Create API"
                                onChange={(e) => {
                                    this.props.programContainer.CreateAPI = e.target.value;
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Update API:
                            </div>

                            <InputText value={this.props.programContainer.UpdateAPI || ''} className='ontario-input' title="Update API"
                                onChange={(e) => {
                                    this.props.programContainer.UpdateAPI = e.target.value;
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Delete API:
                            </div>

                            <InputText value={this.props.programContainer.DeleteAPI || ''} className='ontario-input' title="Delete API"
                                onChange={(e) => {
                                    this.props.programContainer.DeleteAPI = e.target.value;
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Download API:
                            </div>
                            <InputText value={this.props.programContainer.downloadAPI || ''} className='ontario-input'
                                title="Download API"
                                onChange={(e) => {
                                    this.props.programContainer.downloadAPI = e.target.value;
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Analytics API:
                            </div>
                            <InputText value={this.props.programContainer.analyticsAPI || ''} className='ontario-input'
                                title="Analytics API"
                                onChange={(e) => {
                                    this.props.programContainer.analyticsAPI = e.target.value;
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>

                        {showHeaderAttribute("emailAPI", this.props.programContainer.displayForm) && (
                            <div style={{width:"100%",display:"flex",alignItems:"center",marginTop:"5px"}}>
                                <div style={{width:"14%"}}>Email API:</div>
                                <InputText
                                    value={this.props.programContainer.emailAPI || ""}
                                    className="ontario-input"
                                    title="Email API"
                                    onChange={e=>{
                                        this.props.programContainer.emailAPI = e.target.value;
                                        this.props.callback(this.props.programContainer);
                                    }}
                                />
                            </div>
                        )}

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                API-Key:
                            </div>

                            <div style={{ width: '20%' }}>
                                <InputText value={this.props.programContainer.ApiKeyKey || ''} className='ontario-input' title="API-Key Key"
                                    onChange={(e) => {
                                        this.props.programContainer.ApiKeyKey = e.target.value;
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                            <div style={{ width: '45%' }}>
                                <InputText value={this.props.programContainer.ApiKeyValue || ''} className='ontario-input' title="API-Key Value"
                                    onChange={(e) => {
                                        this.props.programContainer.ApiKeyValue = e.target.value;
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        {/*Stepper Selection*/}
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Display Type:
                            </div>
                            {/* @ts-ignore */}
                            <Dropdown
                                // className="p-dropdown"
                                placeholder="Select a stepper type"
                                options={this.displayFormLsit}
                                optionLabel="description"
                                optionValue="value"
                                value={this.props.programContainer.displayForm}
                                onChange={(e) => {
                                    this.props.programContainer.displayForm = e.value;
                                    this.props.callback(this.props.programContainer);
                                }}></Dropdown>
                        </div>
                          <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Select Header:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Dropdown
                                    placeholder="Select header"
                                    options={this.HeaderList}
                                    optionLabel="description"
                                    optionValue="value"
                                    value={this.props.programContainer.HeaderType}
                                    onChange={(e) => {
                                        this.props.programContainer.HeaderType = e.value;

                                        // Auto-enable Exit Popup for Labour header with default values
                                        if (e.value === "Labour") {
                                            this.props.programContainer.EnableExitPopup = "Y";
                                            this.props.programContainer.ExitPopupTitle = this.props.programContainer.ExitPopupTitle || "Are you sure you want to exit?";
                                            this.props.programContainer.ExitPopupMessage = this.props.programContainer.ExitPopupMessage || "If you leave this page your progress will not be saved.";
                                            this.props.programContainer.ExitPopupStayButtonLabel = this.props.programContainer.ExitPopupStayButtonLabel || "Stay on this page";
                                            this.props.programContainer.ExitPopupExitButtonLabel = this.props.programContainer.ExitPopupExitButtonLabel || "Exit without saving";
                                        }

                                        this.props.callback(this.props.programContainer);
                                    }}></Dropdown>
                            </div>
                        </div>

                        {(this.props.programContainer.HeaderType === "Labour" || this.props.programContainer.HeaderType === "ServiceOntario") && (
                            <>
                                <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                                    <div style={{ width: '14%' }}>Enable Exit Popup:</div>
                                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                        {/* @ts-ignore */}
                                        <Checkbox
                                            checked={this.props.programContainer.EnableExitPopup == "Y"}
                                            onChange={(e) => {
                                                this.props.programContainer.EnableExitPopup = e.checked ? "Y" : "N";
                                                if (!e.checked) {
                                                    this.props.programContainer.ExitPopupTitle = "";
                                                    this.props.programContainer.ExitPopupMessage = "";
                                                    this.props.programContainer.ExitPopupStayButtonLabel = "";
                                                    this.props.programContainer.ExitPopupExitButtonLabel = "";
                                                } else {
                                                    this.props.programContainer.ExitPopupTitle = this.props.programContainer.ExitPopupTitle || "Are you sure you want to exit?";
                                                    this.props.programContainer.ExitPopupMessage = this.props.programContainer.ExitPopupMessage || "If you leave this page your progress will not be saved.";
                                                    this.props.programContainer.ExitPopupStayButtonLabel = this.props.programContainer.ExitPopupStayButtonLabel || "Stay on this page";
                                                    this.props.programContainer.ExitPopupExitButtonLabel = this.props.programContainer.ExitPopupExitButtonLabel || "Exit without saving";
                                                }
                                                this.props.callback(this.props.programContainer);
                                            }}
                                        ></Checkbox>
                                    </div>
                                </div>

                                {this.props.programContainer.EnableExitPopup == "Y" && (
                                    <>
                                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                                            <div style={{ width: '14%' }}>Exit Popup Title:</div>
                                            <div style={{ flex: 1, alignItems: 'center', marginTop: '5px' }}>
                                                <InputText
                                                    style={{ width: '100%' }}
                                                    value={this.props.programContainer.ExitPopupTitle || ""}
                                                    onChange={(e) => {
                                                        this.props.programContainer.ExitPopupTitle = e.target.value;
                                                        this.props.callback(this.props.programContainer);
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                                            <div style={{ width: '14%' }}>Exit Popup Message:</div>
                                            <div style={{ flex: 1, alignItems: 'center', marginTop: '5px' }}>
                                                <InputText
                                                    style={{ width: '100%' }}
                                                    value={this.props.programContainer.ExitPopupMessage || ""}
                                                    onChange={(e) => {
                                                        this.props.programContainer.ExitPopupMessage = e.target.value;
                                                        this.props.callback(this.props.programContainer);
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                                            <div style={{ width: '14%' }}>Exit Popup Stay Button Label:</div>
                                            <div style={{ flex: 1, alignItems: 'center', marginTop: '5px' }}>
                                                <InputText
                                                    style={{ width: '100%' }}
                                                    value={this.props.programContainer.ExitPopupStayButtonLabel || ""}
                                                    onChange={(e) => {
                                                        this.props.programContainer.ExitPopupStayButtonLabel = e.target.value;
                                                        this.props.callback(this.props.programContainer);
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                                            <div style={{ width: '14%' }}>Exit Popup Exit Button Label:</div>
                                            <div style={{ flex: 1, alignItems: 'center', marginTop: '5px' }}>
                                                <InputText
                                                    style={{ width: '100%' }}
                                                    value={this.props.programContainer.ExitPopupExitButtonLabel || ""}
                                                    onChange={(e) => {
                                                        this.props.programContainer.ExitPopupExitButtonLabel = e.target.value;
                                                        this.props.callback(this.props.programContainer);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                            </>
                        )}

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>Hide First Page (ontario.ca referer):</div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox
                                    checked={this.props.programContainer.HideFirstPageOnOntarioCaReferer == true}
                                    onChange={(e) => {
                                        this.props.programContainer.HideFirstPageOnOntarioCaReferer = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }}
                                    title="When enabled, hides the first page if the referer is from ontario.ca"
                                ></Checkbox>
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>Initial Client Script:</div>
                            <div style={{ flex: 1, alignItems: 'center', marginTop: '5px' }}>
                                <InputTextarea
                                    style={{ width: '100%' }}
                                    value={this.props.programContainer.InitialClientScript || ""}
                                    onChange={(e) => {
                                        this.props.programContainer.InitialClientScript = e.target.value;
                                        this.props.callback(this.props.programContainer);
                                    }}
                                    placeholder="(programContainer, window) => { /* optional: return stepper index */ }"
                                />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                <label htmlFor="await_initial_client_script">Await script complete:</label>
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px', width: '5%' }}>
                                {/* @ts-ignore */}
                                <Checkbox
                                    id="await_initial_client_script"
                                    checked={!!this.props.programContainer.InitialClientScriptAwait}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.InitialClientScriptAwait = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Select Footer:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                <Dropdown
                                    placeholder="Select footer"
                                    options={this.FooterList}
                                    optionLabel="description"
                                    optionValue="value"
                                    value={this.props.programContainer.FooterType}
                                    onChange={(e) => {
                                        this.props.programContainer.FooterType = e.value;
                                        this.props.callback(this.props.programContainer);
                                    }}></Dropdown>
                            </div>
                        </div>

                        {showHeaderAttribute("HasSaveDraftButton", this.props.programContainer.displayForm) && (
                            <div style={{width:"100%",display:"flex",alignItems:"center",marginTop:"5px"}}>
                                <div style={{width:"14%"}}>Has Save Draft Button:</div>
                                <div style={{alignItems:"center",marginTop:"5px"}}>
                                    {/* @ts-ignore */}
                                    <Checkbox
                                        checked={this.props.programContainer.HasSaveDraftButton=="Y"}
                                        value={this.props.programContainer.HasSaveDraftButton}
                                        className="p-checkbox"
                                        title="Has Save Draft Button"
                                        onChange={e=>{
                                            this.props.programContainer.HasSaveDraftButton=e.checked?"Y":"N";
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                                                
                        <div style={{ width: "100%", display: "flex", alignItems: "center", marginTop: "5px" }}>
                            <div style={{ width: "14%" }}>Auto Save:</div>
                            <div style={{ alignItems: "center", marginTop: "5px" }}>
                                {/* @ts-ignore */}
                                <Checkbox
                                    checked={this.props.programContainer.AutoSavedEnabled}
                                    value={this.props.programContainer.AutoSavedEnabled}
                                    className="p-checkbox"
                                    onChange={e => {
                                        this.props.programContainer.AutoSavedEnabled = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }}
                                />
                            </div>
                        </div>
                        
                        {
                            this.props.programContainer.AutoSavedEnabled &&
                            <div style={{ width: "100%", display: "flex", alignItems: "center", marginTop: "5px" }}>
                                <div style={{ width: "14%" }}>Save Internal (in minutes)</div>
                                <div style={{ alignItems: "center", marginTop: "5px" }}>
                                    <InputText type="number"
                                        value={this.props.programContainer.SaveInterval ?? "2"}
                                        className='ontario-input'
                                        title="Save interval in minutes"
                                        placeholder="Enter a number in minutes"
                                        onChange={(e) => {
                                            this.props.programContainer.SaveInterval = e.target.value;
                                            this.props.callback(this.props.programContainer);
                                        }} />
                                </div>
                            </div>
                        }
                        <div style={{ width: "100%", display: "flex", alignItems: "center", marginTop: "5px" }}>
                            <div style={{ width: "14%" }}>Save Later:</div>
                            <div style={{ alignItems: "center", marginTop: "5px" }}>
                                {/* @ts-ignore */}
                                <Checkbox
                                    checked={this.props.programContainer.saveLaterEnabled}
                                    value={this.props.programContainer.saveLaterEnabled}
                                    className="p-checkbox"
                                    onChange={e => {
                                        this.props.programContainer.saveLaterEnabled = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }}
                                />
                            </div>
                        </div>
                        <div style={{display:"flex",justifyContent:"flex-start",alignItems:"center",paddingLeft:"30px",marginTop:"5px"}}>
                            {/* @ts-ignore */}
                            <Button
                                onClick={()=>{
                                    this.setState({submitDialogVisible:true});
                                }}
                            >
                                Submit properties
                            </Button>
                        </div>
                        {showHeaderAttribute("TopNavigation", this.props.programContainer.displayForm) && (
                            <div style={{width:"100%",display:"flex",alignItems:"center",marginTop:"5px"}}>
                                <div style={{width:"14%"}}>Top navigation:</div>
                                <div style={{alignItems:"center",marginTop:"5px"}}>
                                    {/* @ts-ignore */}
                                    <Checkbox
                                        checked={this.props.programContainer.TopNavigation}
                                        value={this.props.programContainer.TopNavigation}
                                        className="p-checkbox"
                                        onChange={e=>{
                                            this.props.programContainer.TopNavigation=e.checked;
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                        <div style={{width:"100%",display:"flex",alignItems:"center",marginTop:"5px"}}>
                            <div style={{width:"14%"}}>Checkbox Value Y/N:</div>
                            <div style={{alignItems:"center",marginTop:"5px"}}>
                                {/* @ts-ignore */}
                                <Checkbox
                                    checked={this.props.programContainer.CheckboxValueYN=="Y"}
                                    value={this.props.programContainer.CheckboxValueYN}
                                    className="p-checkbox"
                                    title="For some system, boolean value is represented by Y/N"
                                    onChange={e=>{
                                        this.props.programContainer.CheckboxValueYN=e.checked?"Y":"N";
                                        this.props.callback(this.props.programContainer);
                                    }}
                                />
                            </div>
                        </div>
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Use Form Service as Proxy to Access Business API:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.UseProxy == 'Y'} value={this.props.programContainer.UseProxy}
                                    className='p-checkbox' title="Go through Form service to avoid CORS issue"
                                    onChange={(e) => {
                                        this.props.programContainer.UseProxy = e.checked ? 'Y' : 'N';
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Remove Review:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.NoReview == 'Y'} value={this.props.programContainer.NoReview}
                                    className='p-checkbox' title="No review page needed"
                                    onChange={(e) => {
                                        this.props.programContainer.NoReview = e.checked ? 'Y' : 'N';
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Use asterisks for required fields:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.UseAsterisks == 'Y'} value={this.props.programContainer.UseAsterisks}
                                    className='p-checkbox' title="Use asterisks for required fields"
                                    onChange={(e) => {
                                        this.props.programContainer.UseAsterisks = e.checked ? 'Y' : 'N';
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Hide (optional) field labels:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.HideOptionalText == 'Y'} value={this.props.programContainer.HideOptionalText}
                                    className='p-checkbox' title="Hide (optional) labels"
                                    onChange={(e) => {
                                        this.props.programContainer.HideOptionalText = e.checked ? 'Y' : 'N';
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Validate section when browser forward is clicked :
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                <Checkbox checked={this.props.programContainer.ValidateSectionWhenBrowerForwardClicked} 
                                    value={this.props.programContainer.ValidateSectionWhenBrowerForwardClicked}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.ValidateSectionWhenBrowerForwardClicked = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Error display below field :
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.ErrorBottom} value={this.props.programContainer.ErrorBottom}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.ErrorBottom = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                      
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Ontario chat:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.OntarioChat} value={this.props.programContainer.OntarioChat}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.OntarioChat = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        {showHeaderAttribute("NoClearButton", this.props.programContainer.displayForm) && (
                            <div style={{width:"100%",display:"flex",alignItems:"center",marginTop:"5px"}}>
                                <div style={{width:"14%"}}>No Clear Button:</div>
                                <div style={{alignItems:"center",marginTop:"5px"}}>
                                    {/* @ts-ignore */}
                                    <Checkbox
                                        checked={this.props.programContainer.NoClearButton=="Y"}
                                        value={this.props.programContainer.NoClearButton}
                                        className="p-checkbox"
                                        onChange={e=>{
                                            this.props.programContainer.NoClearButton=e.checked?"Y":"N";
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                </div>
                            </div>
                        )}

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Clear form after submit:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.ClearFormAfterSubmit}
                                    value={this.props.programContainer.ClearFormAfterSubmit}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.ClearFormAfterSubmit = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Timeout Popup:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                <Checkbox checked={this.props.programContainer.TimeoutPopup} value={this.props.programContainer.TimeoutPopup}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.TimeoutPopup = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                To Sanitize:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                <Checkbox checked={this.props.programContainer.ToSanitize} value={this.props.programContainer.ToSanitize}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.ToSanitize = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{
                            width: '100%',
                            display: this.props.programContainer.TimeoutPopup ? "flex" : "none",
                            alignItems: 'center',
                            marginTop: '5px'
                        }}>
                            <div style={{ width: '14%' }}>
                                Timeout Redirect URL:
                            </div>
                            <InputText
                                value={(this.props.isEng ? this.props.programContainer.TimeoutRedirectURL : this.props.programContainer.TimeoutRedirectURLFRA) || ''}
                                className='ontario-input'
                                title="URL to redirect to when timeout expires"
                                placeholder={this.props.isEng ? "Enter English redirect URL" : "Enter French redirect URL"}
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        this.props.programContainer.TimeoutRedirectURL = e.target.value;
                                    } else {
                                        this.props.programContainer.TimeoutRedirectURLFRA = e.target.value;
                                    }
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                GA Tracking ID:
                            </div>

                            <InputText value={this.props.programContainer.GATrackingID || ''} className='ontario-input' title="Google Analytics tracking ID"
                                onChange={(e) => {
                                    this.props.programContainer.GATrackingID = e.target.value;
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                GTM Container ID:
                            </div>

                            <InputText value={this.props.programContainer.GTMContainerId || ''} className='ontario-input' title="Google Tag Manager container ID"
                                onChange={(e) => {
                                    this.props.programContainer.GTMContainerId = e.target.value;
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Not Send to GTM:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.sendPageDataToGA === false} value={this.props.programContainer.sendPageDataToGA === false}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.sendPageDataToGA = e.checked ? false : true;
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Handle page-redirection:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                <Checkbox checked={this.props.programContainer.PageRedirection?.shouldHandle} value={this.props.programContainer.PageRedirection?.shouldHandle}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.PageRedirection = { ...this.props.programContainer.PageRedirection ?? {}, shouldHandle: e.checked };
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>

                            <div style={{ alignItems: 'center', paddingLeft: '30px', marginTop: '5px' }}>
                                <Button onClick={() => { this.setState({ pageRedirectionDialogVisible: true }) }}>
                                    Page Redirection
                                </Button>
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Redirect URL:
                            </div>

                            <InputText value={(this.props.isEng ? this.props.programContainer.RedirectURL : this.props.programContainer.RedirectURLFRA) || ''} className='ontario-input' title="Redirect URL"
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        this.props.programContainer.RedirectURL = e.target.value;
                                    } else {
                                        this.props.programContainer.RedirectURLFRA = e.target.value;
                                    }
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Origin Text:
                            </div>

                            <InputText value={(this.props.isEng ? this.props.programContainer.Origin : this.props.programContainer.OriginFRA) || ''} className='ontario-input' title="Go back to"
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        this.props.programContainer.Origin = e.target.value;
                                    } else {
                                        this.props.programContainer.OriginFRA = e.target.value;
                                    }
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Origin URL:
                            </div>

                            <InputText value={(this.props.isEng ? this.props.programContainer.OriginURL : this.props.programContainer.OriginURLFRA) || ''} className='ontario-input' title="Go back to URL"
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        this.props.programContainer.OriginURL = e.target.value;
                                    } else {
                                        this.props.programContainer.OriginURLFRA = e.target.value;
                                    }
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>

                        {(this.props.programContainer.HeaderType === "Labour" || this.props.programContainer.HeaderType === "ServiceOntario") && this.props.programContainer.AuthRequired === "ps" && (
                            <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                                <div style={{ width: '14%' }} >
                                    Dynamic with Public Secure:
                                </div>
                                <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                    {/* @ts-ignore */}
                                    <Checkbox checked={this.props.programContainer.DynamicOriginWithPublicSecure === 'Y'} value={this.props.programContainer.DynamicOriginWithPublicSecure}
                                        className='p-checkbox'
                                        onChange={(e) => {
                                            this.props.programContainer.DynamicOriginWithPublicSecure = e.checked ? 'Y' : 'N';
                                            this.props.callback(this.props.programContainer);
                                        }} />
                                </div>
                            </div>
                        )}

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Build in Social Media:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.SocialMedia == 'Y'} value={this.props.programContainer.SocialMedia}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.SocialMedia = e.checked ? 'Y' : 'N';
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Already Deployed to Production:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.Deployed} value={this.props.programContainer.Deployed}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.Deployed = e.checked
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                English Only:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.EnglishOnly} value={this.props.programContainer.EnglishOnly}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.EnglishOnly = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>


                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Is Horizontal Layout:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.isHorizontalLayout} value={this.props.programContainer.isHorizontalLayout}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.isHorizontalLayout = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Hide Application Name:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.HideApplicationName} value={this.props.programContainer.HideApplicationName}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.HideApplicationName = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Submit as XML:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.SubmitAsXML} value={this.props.programContainer.SubmitAsXML}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.SubmitAsXML = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Email Responses Upon Submit:
                            </div>

                            <div style={{ alignItems: 'center', marginTop: '5px', width: '5%' }}>
                                {/* @ts-ignore */}
                                <Checkbox
                                    checked={this.props.programContainer.EmailCopy}
                                    value={this.props.programContainer.EmailCopy}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.EmailCopy = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }}
                                />
                            </div>

                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Button onClick={() => { this.setState({ emailDialogVisible: true }) }}>
                                    Email contents
                                </Button>
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px', marginLeft: '8px' }}>
                                {/* @ts-ignore */}
                                <Button onClick={() => { this.setState({ inboxDialogVisible: true }) }}>
                                    Inbox contents
                                </Button>
                            </div>
                        </div>

                        <div style={{ display: (this.state.pageRedirectionDialogVisible ? "block" : "none") }}>
                            <DialogForPageRedirectComponent
                                isEng={this.props.isEng}
                                programContainer={this.props.programContainer}
                                dialogVisible={this.state.pageRedirectionDialogVisible}
                                callback={(visible) => {
                                    if (visible != null) {
                                        this.setState({ pageRedirectionDialogVisible: false });
                                    }
                                    this.props.callback(this.props.programContainer);
                                }}
                            />
                        </div>

                        <div style={{ display: (this.state.helpDialogVisible ? "block" : "none") }}>
                            <DialogForEmailContents
                                isEng={this.props.isEng}
                                programContainer={this.props.programContainer}
                                dialogVisible={this.state.emailDialogVisible}
                                callback={(visible) => {
                                    if (visible != null) {
                                        this.setState({ emailDialogVisible: false });
                                    }
                                    this.props.callback(this.props.programContainer);
                                }}
                            />
                        </div>
                        <div style={{ display: (this.state.inboxDialogVisible ? "block" : "none") }}>
                            <DialogForInboxContents
                                isEng={this.props.isEng}
                                programContainer={this.props.programContainer}
                                dialogVisible={this.state.inboxDialogVisible}
                                callback={(visible) => {
                                    if (visible != null) {
                                        this.setState({ inboxDialogVisible: false });
                                    }
                                    this.props.callback(this.props.programContainer);
                                }}
                            />
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Header Init Script:
                            </div>
                            <div style={{ width: '86%' }}>
                                <InputTextarea
                                    className='ontario-input'
                                    style={{ height: '120px', width: '100%' }}
                                    value={this.props.programContainer.HeaderInitScript || ''}
                                    onChange={(e) => {
                                        this.props.programContainer.HeaderInitScript = e.target.value;
                                        this.props.callback(this.props.programContainer);
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }} >
                                Help Option:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px', width: '5%' }}>
                                {/* @ts-ignore */}
                                <Checkbox checked={this.props.programContainer.HelpOption} value={this.props.programContainer.HelpOption}
                                    className='p-checkbox'
                                    onChange={(e) => {
                                        this.props.programContainer.HelpOption = e.checked;
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                {/* @ts-ignore */}
                                <Button
                                    onClick={() => { this.setState({ helpDialogVisible: true }) }}>
                                    Help properties
                                </Button>
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Feedback URL:
                            </div>

                            <InputText value={(this.props.isEng ? this.props.programContainer.FeedbackURL : this.props.programContainer.FeedbackURLFRA) || ''} className='ontario-input' title="Go back to URL"
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        this.props.programContainer.FeedbackURL = e.target.value;
                                    } else {
                                        this.props.programContainer.FeedbackURLFRA = e.target.value;
                                    }
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>

                        {this.props.programContainer.FeedbackURL !== '' && this.props.programContainer.FeedbackURLFRA !== '' && (
                            <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                                <div style={{ width: '14%' }} >
                                    Use this Feedback link:
                                </div>
                                <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                    {/* @ts-ignore */}
                                    <Checkbox checked={this.props.programContainer.useFeedbackUrlOnly} value={this.props.programContainer.useFeedbackUrlOnly}
                                        className='p-checkbox'
                                        onChange={(e) => {
                                            this.props.programContainer.useFeedbackUrlOnly = e.checked;
                                            this.props.callback(this.props.programContainer);
                                        }} />
                                </div>
                            </div>
                        )}

                        <div style={{ display: (this.state.helpDialogVisible ? "block" : "none") }}>
                            <DialogForHelpComponent
                                isEng={this.props.isEng}
                                programContainer={this.props.programContainer}
                                dialogVisible={this.state.helpDialogVisible}
                                callback={(visible) => {
                                    if (visible != null) {
                                        this.setState({ helpDialogVisible: false })
                                    }
                                    this.props.callback(this.props.programContainer);
                                }}>
                            </DialogForHelpComponent>
                        </div>

                        <div style={{ display: (this.state.submitDialogVisible ? "block" : "none") }}>
                            <DialogForSubmitComponent
                                isEng={this.props.isEng}
                                programContainer={this.props.programContainer}
                                dialogVisible={this.state.submitDialogVisible}
                                callback={(visible) => {
                                    if (visible != null) {
                                        this.setState({ submitDialogVisible: false })
                                    }
                                    this.props.callback(this.props.programContainer);
                                }}>
                            </DialogForSubmitComponent>
                        </div>

                        {/* <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Disable Custom Javascript:
                            </div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                <Checkbox checked={this.props.programContainer.DisableJavascript} value={this.props.programContainer.DisableJavascript}
                                    className='p-checkbox' title="Has Save Draft Button"
                                    onChange={(e) => {
                                        this.props.programContainer.DisableJavascript = e.checked;
                                        this.props.callback( this.props.programContainer);
                                    }} />
                            </div>
                        </div> */}

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                PDF Template{!this.props.isEng && FR_SUFFIX}:
                            </div>
                            <div style={{ width: '86%' }}>
                                {/* @ts-ignore */}
                                <FileUpload name={this.props.isEng ? "pdfTemplate" : "pdfTemplateFRA"} customUpload={true} auto={true} multiple={false}
                                    maxFileSize={5000000}
                                    onRemove={this.fileUploader}
                                    uploadHandler={this.fileUploader} />
                            </div>
                        </div>
                        <div style={{ width: '100%', display: this.props.isEng ? this.props.programContainer.pdfTemplate ? "flex" : 'none' : this.props.programContainer.pdfTemplateFRA ? "flex" : 'none', alignItems: 'center', marginTop: '5px' }}>
                            {/* <div style={{ width: '14%' }}>
                                Uploaded PDF Template:
                            </div> */}
                            <div style={{ width: '100%' }}>
                                {/* @ts-ignore */}
                                <Panel collapsed={true} toggleable header={`Uploaded PDF Template${this.props.isEng ? '' : FR_SUFFIX}`}>
                                    <div style={{ resize: 'vertical', overflow: 'auto', minHeight: '240px' }}>
                                        <object style={{ width: '100%', height: '100%' }} data={this.props.isEng ? this.props.programContainer.pdfTemplate : this.props.programContainer.pdfTemplateFRA} />
                                    </div>
                                    <div>
                                        {/* @ts-ignore */}
                                        <Button onClick={(e) => {
                                            if (this.props.isEng) {
                                                this.props.programContainer.pdfTemplate = null;
                                            } else {
                                                this.props.programContainer.pdfTemplateFRA = null;
                                            }
                                            this.props.callback(this.props.programContainer);
                                        }}>
                                            Remove PDF Template {!this.props.isEng && FR_SUFFIX}
                                        </Button>
                                    </div>
                                </Panel>
                            </div>
                        </div>
                        {/* Return to Summary Button Section */}
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Return to Summary Button:
                            </div>
                            <div style={{ alignItems: 'center' }}>
                                {/* @ts-ignore */}
                                <Checkbox
                                    checked={this.props.programContainer.ReturnToSummaryButton === true}
                                    className='p-checkbox'
                                    title="Show a button on each page that takes the user back to the summary page when editing from summary"
                                    onChange={(e) => {
                                        this.props.programContainer.ReturnToSummaryButton = e.checked;
                                        if (!e.checked) {
                                            this.props.programContainer.ReturnToSummaryButtonLabel = '';
                                            this.props.programContainer.ReturnToSummaryButtonLabelFRA = '';
                                        }
                                        this.props.callback(this.props.programContainer);
                                    }}
                                />
                            </div>
                        </div>
                        {this.props.programContainer.ReturnToSummaryButton && (
                            <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                                <div style={{ width: '14%' }}>
                                    Button Label:
                                </div>
                                <InputText
                                    value={(this.props.isEng
                                        ? this.props.programContainer.ReturnToSummaryButtonLabel
                                        : this.props.programContainer.ReturnToSummaryButtonLabelFRA) || ''}
                                    className='ontario-input'
                                    placeholder={this.props.isEng ? 'e.g. Return to summary' : 'e.g. Retour au sommaire'}
                                    onChange={(e) => {
                                        if (this.props.isEng) {
                                            this.props.programContainer.ReturnToSummaryButtonLabel = e.target.value;
                                        } else {
                                            this.props.programContainer.ReturnToSummaryButtonLabelFRA = e.target.value;
                                        }
                                        this.props.callback(this.props.programContainer);
                                    }}
                                />
                            </div>
                        )}

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Creator:
                            </div>
                            <div style={{ width: '86%' }}>
                                {this.props.programContainer.Creator}
                            </div>
                        </div>
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Co-owners:
                            </div>
                            <div style={{ width: '86%' }}>
                                {isCreator ? (
                                    <AzureUsersLookUpComponent
                                        userList={this.props.programContainer.Coowners}
                                        callback={(newUserList) => {
                                            // Only creator can update
                                            if (!this.isCurrentUserCreator()) return;
                                            this.props.programContainer.Coowners = newUserList;
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                ) : (
                                    <div style={{ padding: '4px 0' }}>
                                        {(this.props.programContainer.Coowners || []).length === 0 && (
                                            <span style={{ fontStyle: 'italic', color: '#555' }}>No co-owners</span>
                                        )}
                                        {(this.props.programContainer.Coowners || []).map(u => (
                                            <span
                                                key={(u.userId || u.email || u.userName)}
                                                style={{
                                                    display: 'inline-block',
                                                    background: '#eef2f5',
                                                    border: '1px solid #d3d9dd',
                                                    borderRadius: '12px',
                                                    padding: '2px 10px',
                                                    margin: '2px 6px 2px 0',
                                                    fontSize: '0.85rem'
                                                }}
                                                title={u.email || u.userName}
                                            >
                                                {(u.displayName || `${u.firstName || ''} ${u.lastName || ''}` || u.email || u.userName)}
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div style={{ width: '100%', display: this.props.programContainer?.CategoryId?.toLowerCase().startsWith('bxp-') ? "block" : "none", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Custom Summary Header:
                            </div>
                            <div style={{ paddingRight: '5px', width: '86%', display: this.props.programContainer?.CategoryId?.toLowerCase().startsWith('bxp-') ? "block" : "none" }}>
                                {/* @ts-ignore */}
                                {this.customSummaryHeaderEditor && (
                                    <Editor
                                        className='ontario-input ontario-margin-bottom-0-!'
                                        placeholder='Message Body'
                                        title="Message Body"
                                        value={this.props.isEng ? this.props.programContainer.CustomSummaryHeader : this.props.programContainer.CustomSummaryHeaderFRA || ""}
                                        onTextChange={(e) => {
                                            if (this.props.isEng) {
                                                this.props.programContainer.CustomSummaryHeader = e.htmlValue;
                                            } else {
                                                this.props.programContainer.CustomSummaryHeaderFRA = e.htmlValue;
                                            }
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                )}
                                {!this.customSummaryHeaderEditor && (
                                    <InputTextarea
                                        value={this.props.isEng ? this.props.programContainer.CustomSummaryHeader : this.props.programContainer.CustomSummaryHeaderFRA || ""}
                                        onChange={(e) => {
                                            if (this.props.isEng) {
                                                this.props.programContainer.CustomSummaryHeader = e.target.value;
                                            } else {
                                                this.props.programContainer.CustomSummaryHeaderFRA = e.target.value;
                                            }
                                            this.props.callback(this.props.programContainer);
                                        }}
                                        style={{ height: '100px', width: '100%' }}
                                    />
                                )}
                                <button onClick={() => {
                                    this.customSummaryHeaderEditor = !this.customSummaryHeaderEditor;
                                    this.props.callback(this.props.programContainer);
                                }}>
                                    {this.customSummaryHeaderEditor == true ? "Raw" : "HTML"}
                                </button>
                            </div>
                        </div>
                        <div style={{ width: '100%', display: this.props.programContainer?.CategoryId?.toLowerCase().startsWith('bxp-') ? "block" : "none", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                Custom Application Header:
                            </div>
                            <div style={{ paddingRight: '5px', width: '86%' }}>
                                {/* @ts-ignore */}
                                {this.customApplicationHeaderEditor && (
                                    <Editor
                                        className='ontario-input ontario-margin-bottom-0-!'
                                        placeholder='Message Body'
                                        title="Message Body"
                                        value={this.props.isEng ? this.props.programContainer.CustomApplicationHeader : this.props.programContainer.CustomApplicationHeaderFRA || ""}
                                        onTextChange={(e) => {
                                            if (this.props.isEng) {
                                                // Default FR if needed
                                                if (Utils.willDefaultFR(this.props.programContainer.CustomApplicationHeader, this.props.programContainer.CustomApplicationHeaderFRA)) {
                                                    this.props.programContainer.CustomApplicationHeaderFRA = Utils.isNullOrEmpty(e.htmlValue) ? '' : e.htmlValue + FR_SUFFIX;
                                                }
                                                this.props.programContainer.CustomApplicationHeader = e.htmlValue;
                                            } else {
                                                this.props.programContainer.CustomApplicationHeaderFRA = e.htmlValue;
                                            }
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                )}
                                {!this.customApplicationHeaderEditor && (
                                    <InputTextarea
                                        value={this.props.isEng ? this.props.programContainer.CustomApplicationHeader : this.props.programContainer.CustomApplicationHeaderFRA || ""}
                                        onChange={(e) => {
                                            if (this.props.isEng) {
                                                // Default FR if needed
                                                if (Utils.willDefaultFR(this.props.programContainer.CustomApplicationHeader, this.props.programContainer.CustomApplicationHeaderFRA)) {
                                                    this.props.programContainer.CustomApplicationHeaderFRA = Utils.isNullOrEmpty(e.target.value) ? '' : e.target.value + FR_SUFFIX;
                                                }
                                                this.props.programContainer.CustomApplicationHeader = e.target.value;
                                            } else {
                                                this.props.programContainer.CustomApplicationHeaderFRA = e.target.value;
                                            }
                                            this.props.callback(this.props.programContainer);
                                        }}
                                        style={{ height: '100px', width: '100%' }}
                                    />
                                )}
                                <button onClick={() => {
                                    this.customApplicationHeaderEditor = !this.customApplicationHeaderEditor;
                                    this.props.callback(this.props.programContainer);
                                }}>
                                    {this.customApplicationHeaderEditor == true ? "Raw" : "HTML"}
                                </button>
                            </div>
                        </div>


                        <div style={{ width: '100%', display: this.props.programContainer?.CategoryId?.toLowerCase().startsWith('bxp-') ? "block" : "none", alignItems: 'center', marginTop: '5px' }}>
                            <div style={{ width: '14%' }}>
                                BXP configuration metadata:
                            </div>
                            <div style={{ paddingRight: '5px', width: '86%' }}>
                                <InputTextarea value={(this.props.isEng ? this.props.programContainer.MetaData : this.props.programContainer.MetaData) || ''} title="Meda Data"
                                    onChange={(e) => {
                                        this.props.programContainer.MetaData = e.target.value;
                                        this.props.callback(this.props.programContainer);
                                    }}
                                    style={{ height: '100px', width: '100%' }} />
                            </div>
                        </div>

                        {/* Global Key-Value Pairs Section */}
                        <div style={{ marginTop: '20px', borderTop: '1px solid #ddd', paddingTop: '20px' }}>
                            <GlobalKeyValuePairsComponent
                                programContainer={this.props.programContainer}
                                callback={this.props.callback}
                                isEng={this.props.isEng}
                            />
                        </div>

                    </Panel>

                    {/* @ts-ignore */}
                    <Dialog
                        header="Upload Application Screenshots"
                        visible={this.state.screenshotDialogVisible}
                        style={{ width: '650px', fontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif" }}
                        onHide={() => { if (!this.state.screenshotUploading) this.setState({ screenshotDialogVisible: false, pastedScreenshots: [] }); }}
                        closable={!this.state.screenshotUploading}
                    >
                        <div style={{ marginBottom: '1rem' }}>
                            <p style={{ margin: '0 0 1rem 0', color: '#1A1A1A', fontSize: '1rem', lineHeight: 1.6 }}>
                                Upload or paste (Ctrl+V) screenshots of your application pages. The AI will analyze
                                the images and automatically create form sections with the appropriate fields.
                            </p>
                            <p style={{ margin: '0 0 1rem 0', color: '#666', fontSize: '0.875rem', lineHeight: 1.6 }}>
                                Supported formats: PNG, JPG, GIF, WebP.
                            </p>
                        </div>
                        <div style={{ marginBottom: '1.5rem' }}>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, fontSize: '1rem', color: '#1A1A1A' }}>Additional instructions (optional)</label>
                            <textarea
                                value={this.state.screenshotAdditionalPrompt}
                                onChange={(e) => this.setState({ screenshotAdditionalPrompt: e.target.value })}
                                placeholder="e.g. This is a summary page. Generate read-only sections from previously generated sections."
                                style={{
                                    width: '100%',
                                    minHeight: '60px',
                                    padding: '0.75rem',
                                    borderRadius: '4px',
                                    border: '2px solid #1A1A1A',
                                    fontSize: '1rem',
                                    lineHeight: 1.6,
                                    fontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
                                    resize: 'vertical',
                                    boxSizing: 'border-box',
                                    transition: 'box-shadow 0.2s, border-color 0.2s',
                                    outline: 'none',
                                }}
                                onFocus={(e) => { e.currentTarget.style.borderColor = '#009ADB'; e.currentTarget.style.boxShadow = '0 0 0 4px #009ADB'; }}
                                onBlur={(e) => { e.currentTarget.style.borderColor = '#1A1A1A'; e.currentTarget.style.boxShadow = 'none'; }}
                            />
                        </div>
                            {this.state.screenshotUploading ? (
                                <div style={{ textAlign: 'center', padding: '2rem', backgroundColor: '#E2F0F4', borderRadius: '4px', border: '1px solid #1080A6' }}>
                                    <ProgressBar mode="indeterminate" style={{ height: '6px' }} />
                                    <p style={{ marginTop: '1rem', color: '#1A1A1A', fontSize: '1rem', lineHeight: 1.6 }}>Analyzing screenshots with AI... Validating results against original images.</p>
                                </div>
                            ) : (
                                <div>
                                    {/* Paste zone */}
                                    <div
                                        tabIndex={0}
                                        onPaste={(e) => {
                                            const items = e.clipboardData?.items;
                                            if (!items) return;
                                            const imageFiles: File[] = [];
                                            for (let i = 0; i < items.length; i++) {
                                                if (items[i].type.startsWith('image/')) {
                                                    const file = items[i].getAsFile();
                                                    if (file) imageFiles.push(file);
                                                }
                                            }
                                            if (imageFiles.length > 0) {
                                                this.setState(prev => ({
                                                    pastedScreenshots: [...prev.pastedScreenshots, ...imageFiles]
                                                }));
                                            }
                                        }}
                                        onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                        onDrop={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            const droppedFiles = Array.from(e.dataTransfer.files).filter(f => f.type.startsWith('image/'));
                                            if (droppedFiles.length > 0) {
                                                this.setState(prev => ({
                                                    pastedScreenshots: [...prev.pastedScreenshots, ...droppedFiles]
                                                }));
                                            }
                                        }}
                                        style={{
                                            border: '2px dashed #CCC',
                                            borderRadius: '4px',
                                            padding: '2rem',
                                            textAlign: 'center',
                                            color: '#666',
                                            cursor: 'pointer',
                                            marginBottom: '1.5rem',
                                            backgroundColor: '#F2F2F2',
                                            outline: 'none',
                                            minHeight: '80px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            transition: 'border-color 0.2s, background-color 0.2s',
                                            fontSize: '1rem',
                                            lineHeight: 1.6,
                                        }}
                                        onFocus={(e) => { e.currentTarget.style.borderColor = '#009ADB'; e.currentTarget.style.boxShadow = '0 0 0 4px #009ADB'; }}
                                        onBlur={(e) => { e.currentTarget.style.borderColor = '#CCC'; e.currentTarget.style.boxShadow = 'none'; }}
                                    >
                                        <i className="pi pi-clipboard" style={{ fontSize: '2rem', marginBottom: '0.5rem', color: '#666' }}></i>
                                        <span>Click here and press <strong>Ctrl+V</strong> to paste, or drag &amp; drop images</span>
                                    </div>

                                    {/* Pasted image thumbnails */}
                                    {this.state.pastedScreenshots.length > 0 && (
                                        <div style={{ marginBottom: '1.5rem' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
                                                <strong style={{ color: '#1A1A1A', fontSize: '1rem' }}>{this.state.pastedScreenshots.length} pasted image(s)</strong>
                                                <button
                                                    style={{
                                                        background: 'none', border: 'none', color: '#0066CC', cursor: 'pointer',
                                                        fontSize: '1rem', textDecoration: 'underline', fontFamily: "'Open Sans', sans-serif",
                                                    }}
                                                    onClick={() => this.setState({ pastedScreenshots: [] })}
                                                >
                                                    Clear all
                                                </button>
                                            </div>
                                            <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                                                {this.state.pastedScreenshots.map((file, idx) => (
                                                    <div key={idx} style={{ position: 'relative', display: 'inline-block' }}>
                                                        <img
                                                            src={URL.createObjectURL(file)}
                                                            alt={`Screenshot ${idx + 1}`}
                                                            style={{ width: '100px', height: '70px', objectFit: 'cover', borderRadius: '4px', border: '2px solid #CCC' }}
                                                        />
                                                        <button
                                                            onClick={() => this.setState(prev => ({
                                                                pastedScreenshots: prev.pastedScreenshots.filter((_, i) => i !== idx)
                                                            }))}
                                                            style={{
                                                                position: 'absolute', top: '-8px', right: '-8px',
                                                                background: '#CD0000', color: '#fff', border: 'none',
                                                                borderRadius: '50%', width: '22px', height: '22px',
                                                                cursor: 'pointer', fontSize: '14px', lineHeight: '22px',
                                                                padding: 0, textAlign: 'center',
                                                            }}
                                                            aria-label={`Remove screenshot ${idx + 1}`}
                                                        >
                                                            ×
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                            {/* @ts-ignore */}
                                            <Button
                                                label={`Analyze ${this.state.pastedScreenshots.length} Image(s)`}
                                                icon="pi pi-bolt"
                                                style={{
                                                    marginTop: '1rem', width: '100%',
                                                    backgroundColor: '#0066CC', borderColor: '#0066CC', color: '#fff',
                                                    fontFamily: "'Open Sans', sans-serif", fontSize: '1.125rem', fontWeight: 600,
                                                    padding: '0.75rem 1.5rem', borderRadius: '4px',
                                                }}
                                                onClick={async () => {
                                                    this.setState({ screenshotUploading: true, screenshotError: null });
                                                    try {
                                                        const analyses = await analyzeScreenshots(this.state.pastedScreenshots, this.state.screenshotAdditionalPrompt);
                                                        populateFormFromAnalysis(this.props.programContainer, analyses, this.state.screenshotAdditionalPrompt);
                                                        this.props.callback(this.props.programContainer);
                                                        this.setState({
                                                            screenshotDialogVisible: false,
                                                            screenshotUploading: false,
                                                            screenshotError: null,
                                                            pastedScreenshots: [],
                                                            screenshotAdditionalPrompt: ''
                                                        });
                                                        // Auto-save to DB after analysis
                                                        if (this.props.callbackSave) {
                                                            this.props.callbackSave();
                                                        }
                                                        this.growl?.show({ severity: 'success', summary: 'Success', detail: `${analyses.length} section(s) created from screenshots.`, life: 5000 });
                                                    } catch (err) {
                                                        console.error('Screenshot analysis failed:', err);
                                                        this.setState({
                                                            screenshotUploading: false,
                                                            screenshotError: err?.message || 'Failed to analyze screenshots. Please try again.'
                                                        });
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}

                                </div>
                            )}
                            {this.state.screenshotError && (
                                <div style={{ color: '#CD0000', backgroundColor: '#FCEFF0', padding: '0.75rem 1rem', borderRadius: '4px', marginTop: '1rem', borderLeft: '4px solid #CD0000', fontSize: '1rem', lineHeight: 1.6 }}>
                                    {this.state.screenshotError}
                                </div>
                            )}
                        </Dialog>

                </div>
            </div >
        )

        htmlString.push(this.getFormSection(formSectionsList));

        htmlString.push(
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', verticalAlign: 'middle', alignContent: 'center' }}>
                <div className='ontario-div' >
                    {/* @ts-ignore */}
                    <Dropdown placeholder="Select a Section Template Saved Before" options={this.state.templateList} optionLabel="description" optionValue="code" onChange={(e) => {
                        let section = parseJson(e.value, this.props.programContainer.CategoryId);
                        const maxSequence = formSectionsList.reduce((max, obj) => obj.Sequence > max ? obj.Sequence : max, formSectionsList[0].Sequence);
                        section.Sequence = maxSequence + 1;
                        section.Id = section.Sequence.toString();
                        formSectionsList.push(section);
                        this.props.callback(this.props.programContainer);
                    }}></Dropdown>
                </div>
                <div className='ontario-div'  >
                    {/* @ts-ignore */}
                    <Button className="p-button-warning" onClick={() => {
                        let section = new FormSections();
                        section.Visible = true;
                        section.ListOfFormSubSections = [];
                        section.parent = this.props.programContainer;
                        let subSection = new FormSubSections();
                        subSection.parent = section;
                        section.ListOfFormSubSections.push(subSection);
                        subSection.Sequence = 1;
                        if (subSection.ListOfFormSectionElements) {
                            subSection.ListOfFormSectionElements = [];
                        }
                        // section.Id = (Math.max(...formSectionsList.map(({Id}) => parseInt(Id))) + 1).toString();
                        const maxId = formSectionsList.reduce((max, item) => {
                            return Math.max(max, parseInt(item.Id)) + 1;
                        }, 1);
                        section.Id = maxId.toString();
                        section.ENUTitle = "Section " + section.Id;
                        //section.FRATitle = "[FR] Section " + section.Id;
                        section.Sequence = formSectionsList.length + 1;
                        formSectionsList.push(section);
                        this.props.callback(this.props.programContainer);
                    }}>Add Section</Button>
                </div>
            </div>
        )
        return htmlString;
    }

    getFormSection(formSectionsList) {
        let htmlString = [];
        formSectionsList.sort((a, b) => a.Sequence - b.Sequence).forEach((formSection, index) => {

    
            let panelHtml = [];
            formSection.ListOfFormSubSections.sort((a, b) => a.Sequence - b.Sequence).forEach(subSection => {
                if (!subSection.IsDuplicate) panelHtml.push(
                    <>
                        {/* @ts-ignore */}
                        <Panel
                            header={this.props.isEng ? subSection.ENUTitle : subSection.FRATitle || ''} toggleable>
                            {this.generatePanels(subSection)}
                        </Panel>
                    </>
                );
            });

            htmlString.push(
                <>
                    {/* @ts-ignore */}
                    <Panel
                        key={'Panel_' + index}
                        headerTemplate={(options) => {
                            const titleText = this.props.isEng
                                ? formSection.ENUTitle + " (Sequence: " + formSection.Sequence + ")"
                                : formSection.FRATitle + " (" + index + ")";
                            return (
                                <div className={options.className} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}>
                                    <span onClick={options.onTogglerClick} style={{ flex: 1 }}>{titleText}</span>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                        <button
                                            type="button"
                                            title="Remove section"
                                            className="p-panel-header-icon p-link"
                                            style={{ color: '#CD0000', border: 'none', background: 'none', cursor: 'pointer', fontSize: '1rem' }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.showConfirmation(() => {
                                                    var formSectionsList = this.props.programContainer.ListOfFormSections.filter(p => p.Id !== formSection.Id);
                                                    for (let i = 0; i < formSectionsList.length; i++) {
                                                        if (i == 0 && formSectionsList[i].Sequence != 1) {
                                                            formSectionsList[i].Sequence = 1;
                                                        }
                                                        if (i > 0 && (formSectionsList[i].Sequence - formSectionsList[i - 1].Sequence) > 1) {
                                                            formSectionsList[i].Sequence = formSectionsList[i - 1].Sequence + 1;
                                                        }
                                                    }
                                                    this.props.programContainer.ListOfFormSections = formSectionsList;
                                                    this.props.callback(this.props.programContainer);
                                                });
                                            }}
                                        >
                                            <span className="pi pi-times"></span>
                                        </button>
                                        <button
                                            type="button"
                                            className="p-panel-header-icon p-link"
                                            onClick={options.onTogglerClick}
                                        >
                                            <span className={options.collapsed ? 'pi pi-plus' : 'pi pi-minus'}></span>
                                        </button>
                                    </span>
                                </div>
                            );
                        }}
                        toggleable
                        collapsed={this.state.panelCollapsed[formSection.Id]}
                        onToggle={(e) => {
                            const panelArray = [...this.state.panelCollapsed];
                            panelArray[formSection.Id] = e.value;
                            this.setState({
                                panelCollapsed: panelArray
                            })
                        }}
                    >
                        {this.generateHeader(formSection)}
                        {panelHtml}
                    </Panel>
                </>
            )
        })

        return htmlString;
    }

    generatePanels = (subSection: FormSubSections) => {
        let htmlString = [];
        const divStyle = {
            backgroundColor: '#888888', // Specify the desired background color
            paddingTop: '10px',
            marginBottom: '10px',
            width: '100%',
        };

        htmlString.push(
            <div key={"panel_" + subSection.Sequence}>
                {this.generateSubSections(subSection)}

            </div>
        )

        return htmlString;
    }

    generateSubSections = (formSubSections: FormSubSections) => {
        let htmlString = [];

        let formSection = formSubSections.parent as FormSections;
        const divStyle = {
            backgroundColor: '#999999', // Specify the desired background color
            padding: '10px',
            marginBottom: '10px',
        };

        let sectionButtons = [
            {
                label: 'Setup Data API',
                visible: formSection.ListOfFormSubSections.length == formSubSections.Sequence,
                icon: 'pi pi-cloud',
                command: () => {
                    const apiDialogVisible = [...this.state.apiDialogVisible];
                    apiDialogVisible[formSection.Id] = true;
                    this.setState({ apiDialogVisible });
                    this.props.callback(this.props.programContainer);
                }
            },
            {
                label: 'Remove Section',
                visible: formSection.ListOfFormSubSections.length === formSubSections.Sequence,
                icon: 'pi pi-times',
                command: () => {
                    this.showConfirmation(() => {
                        var formSectionsList = this.props.programContainer.ListOfFormSections.filter(p => p.Id !== formSection.Id);

                        // shift Sections's Sequence numbers so they are continuous (for move up/down to work properly)
                        for (let i = 0; i < formSectionsList.length; i++) {
                            if (i == 0 && formSectionsList[i].Sequence != 1) {
                                formSectionsList[i].Sequence = 1;
                            }

                            if (i > 0 && (formSectionsList[i].Sequence - formSectionsList[i - 1].Sequence) > 1) {
                                formSectionsList[i].Sequence = formSectionsList[i - 1].Sequence + 1;
                            }

                        }

                        this.props.programContainer.ListOfFormSections = formSectionsList;
                        this.props.callback(this.props.programContainer);
                    });
                }
            },
            {
                label: 'Save Section as Template',
                visible: formSection.ENUTitle != null && formSection.ListOfFormSubSections.length == formSubSections.Sequence,
                icon: 'pi pi-star',
                command: () => {
                    let token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
                    const headers = {
                        'Authorization': `Bearer ${token}`
                    }
                    let api = "data/admin/save"
                    let entity = { categoryName: formSection.ENUTitle, formType: 'Template', attachment: stringifyJson(formSection, this.props.programContainer.CategoryId) }
                    axios.post(URLUtils.concatUrls(api), entity, { withCredentials: true, headers: headers }).then(
                        (result) => {
                            this.growl.show({ severity: 'success', summary: 'Success Message', detail: 'Template saved' });
                        }
                    ).catch((error) => {
                        const resBody = error.response.data;
                        for (const e of resBody.errors) {
                            if (resBody.message == "Data input is not valid" && e.split(':')[1] == " Application Name cannot be blank") {
                                this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Section Title cannot be blank' });
                            } else {
                                this.growl.show({ severity: 'error', summary: 'Error Message', detail: e });
                            }
                        }
                    })
                }
            },
            {
                label: 'Export Section as JSON',
                visible: formSection.ENUTitle != null && formSection.ListOfFormSubSections.length == formSubSections.Sequence,
                icon: 'pi pi-download',
                command: () => {
                    this.exportSectionAsJson(formSection);
                }
            },
            {
                label: 'Import Section from JSON',
                visible: formSection.ENUTitle != null && formSection.ListOfFormSubSections.length == formSubSections.Sequence,
                icon: 'pi pi-upload',
                command: () => {
                    const sectionImportDialogVisible = [...this.state.sectionImportDialogVisible];
                    sectionImportDialogVisible[formSection.Id] = true;
                    this.setState({ sectionImportDialogVisible });
                }
            },
            {
                label: 'Remove Subsection',
                icon: 'pi pi-times',
                visible: formSection.ListOfFormSubSections.length > 1,
                command: () => {
                    this.showConfirmation(() => {
                        const formSubsectionsList = formSection.ListOfFormSubSections.filter(p => p.Id !== formSubSections.Id);
                        
                        // Resequence subsections so they are continuous (for display conditions to work properly)
                        for (let i = 0; i < formSubsectionsList.length; i++) {
                            formSubsectionsList[i].Sequence = i + 1;
                            formSubsectionsList[i].Id = formSubsectionsList[i].Sequence.toString();
                        }
                        
                        formSection.ListOfFormSubSections = formSubsectionsList;
                        this.props.callback(this.props.programContainer);
                    });
                }
            },
            {
                label: 'Add Subsection',
                icon: 'pi pi-plus',
                visible: formSection.ENUTitle != null,
                command: () => {
                    let subSection = new FormSubSections();
                    subSection.Sequence = formSection.ListOfFormSubSections.length + 1;
                    subSection.Id = subSection.Sequence.toString();
                    subSection.Visible = true;
                    subSection.parent = formSection;
                    formSection.ListOfFormSubSections.push(subSection);
                    this.props.callback(this.props.programContainer);
                }
            }
        ]

        let subSectionButtons = [
            {
                label: 'Add Subsection',
                icon: 'pi pi-plus',
                visible: formSection.ENUTitle != null,
                command: () => {
                    let subSection = new FormSubSections();
                    subSection.Sequence = formSubSections.Sequence + 1;
                    // formSubSections.Sequence=formSubSections.Sequence+1;
                    formSection.ListOfFormSubSections.forEach(p => {
                        if (p.Sequence > formSubSections.Sequence) {
                            p.Sequence = p.Sequence + 1;
                            p.Id = p.Sequence.toString();
                        }
                    })
                    subSection.Id = subSection.Sequence.toString();
                    subSection.Visible = true;
                    subSection.parent = formSection;
                    formSection.ListOfFormSubSections.push(subSection);
                    this.props.callback(this.props.programContainer);
                }
            },
            {
                label: 'Remove Subsection',
                icon: 'pi pi-times',
                visible: formSection.ListOfFormSubSections.length > 1,
                command: () => {
                    this.showConfirmation(() => {
                        const formSubsectionsList = formSection.ListOfFormSubSections.filter(p => p.Id !== formSubSections.Id);
                        
                        // Resequence subsections so they are continuous (for display conditions to work properly)
                        for (let i = 0; i < formSubsectionsList.length; i++) {
                            formSubsectionsList[i].Sequence = i + 1;
                            formSubsectionsList[i].Id = formSubsectionsList[i].Sequence.toString();
                        }
                        
                        formSection.ListOfFormSubSections = formSubsectionsList;
                        this.props.callback(this.props.programContainer);
                    });
                }
            },

        ]


        let header = (
            <div>
                <div>
                    <InputText placeholder="Sub Section Title" title="Sub Section Title" className="ontario-input" style={{ width: '100%', }}
                        value={(this.props.isEng ? formSubSections.ENUTitle : formSubSections.FRATitle) || ''} onChange={(e) => {
                            if (this.props.isEng) {
                                if (Utils.willDefaultFR(formSubSections.ENUTitle, formSubSections.FRATitle)) {
                                    formSubSections.FRATitle = Utils.isNullOrEmpty(e.target.value) ? '' : e.target.value + FR_SUFFIX;
                                }
                                formSubSections.ENUTitle = e.target.value;
                            } else {
                                formSubSections.FRATitle = e.target.value;
                            }
                            this.props.callback(this.props.programContainer);
                        }} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-start', width: '10%', paddingLeft: '5px' }} key={"chk_readonly_richtext"}>
                    <div><label htmlFor={'chk_formSubSections_richtext' + formSubSections.Id + formSubSections.Sequence?.toString()} />srOnly&nbsp;</div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_formSubSections_richtext' + formSubSections.Id + formSubSections.Sequence?.toString()} disabled={this.props.isEng == false}
                            checked={formSubSections.RichTextChecked}
                            onChange={(e) => {
                                formSubSections.RichTextChecked = e.checked;
                                this.props.callback(this.props.programContainer)
                            }}>
                        </Checkbox>
                    </div>
                </div>
                <div style={{ width: '100%', paddingTop: '10px' }}>
                    <InputTextarea placeholder="Additional Description/Instructions" title="Additional Description/Instructions" className="ontario-input"
                        value={(this.props.isEng ? formSubSections.ENUDescription : formSubSections.FRADescription) || ''} onChange={(e) => {
                            if (this.props.isEng) {
                                if (Utils.willDefaultFR(formSubSections.ENUDescription, formSubSections.FRADescription)) {
                                    formSubSections.FRADescription = Utils.isNullOrEmpty(e.target.value) ? '' : e.target.value + FR_SUFFIX;
                                }
                                formSubSections.ENUDescription = e.target.value;
                            } else {
                                formSubSections.FRADescription = e.target.value;
                            }
                            this.props.callback(this.props.programContainer);
                        }} />
                </div>

            </div>
        )
        htmlString.push(
            formSubSections.parent.CustomizedReviewPage ?
                <div style={{ display: "flex", marginBottom: '5px' }}>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_NoCardInSummary' + formSubSections.Id}
                            key={'chk_NoCardInSummary' + formSubSections.Id}
                            checked={formSubSections.NoCardInSummary}
                            onChange={(e) => {
                                formSubSections.NoCardInSummary = e.checked;
                                this.props.callback(this.props.programContainer);
                            }}></Checkbox>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <label htmlFor={'chk_NoCardInSummary' + formSubSections.Id} className="p-checkbox-label">Not
                            inside card</label>
                    </div>
                </div>
                :
                <div style={{ display: "flex", marginBottom: '5px' }}>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_displayInCard' + formSubSections.Id}
                            key={'chk_displayInCard' + formSubSections.Id}
                            checked={formSubSections.displayInCard}
                            onChange={(e) => {
                                formSubSections.displayInCard = e.checked;
                                this.props.callback(this.props.programContainer);
                            }}></Checkbox>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <label
                            htmlFor={'chk_displayInCard' + formSubSections.Id}
                            className="p-checkbox-label">
                            Display in Card
                        </label>
                    </div>
                </div>
        );

        htmlString.push(header);



        formSubSections.ListOfFormSectionElements
            .sort((a, b) => a.Sequence - b.Sequence)
            .forEach((ele, index) => {
                ele.parent = formSubSections;
                if (ele.Sequence != (index + 1))
                    ele.Sequence = index + 1; // reset sequence numbers of elements into consecutive numbers
                let elementHtml = this.generateElement(ele);
                let sectionName = ele.ENUTitle + "";
                htmlString.push(
                    <div style={{ marginTop: '20px' }} key={ele.Id + "_panel_" + formSubSections.ENUTitle + ele.Sequence}>
                        {/* @ts-ignore */}
                        <Panel key={'Panel_' + index} header={'Element ' + (index + 1).toString() + " - " + (ele.shareReferenceId ? 'Reference to: '+ele.shareReferenceId : sectionName)} toggleable >
                            {elementHtml}
                        </Panel>
                    </div>

                )
            });


        // Always show subsection property button, but only show move up/down when there are multiple subsections
        htmlString.push(
            <div className='ontario-div' style={{ display: 'flex', justifyContent: 'space-between' }}>
                {formSubSections.parent.ListOfFormSubSections.length > 1 && (
                    <div style={{ flex: 1, visibility: formSubSections.Sequence > 1 ? 'visible' : 'hidden' }}>
                        <button className="ontario-button ontario-button--secondary" onClick={(e) => {
                            let currentIndex = formSubSections.Sequence;
                            let lastSubSection = formSubSections.parent.ListOfFormSubSections[currentIndex - 2];
                            lastSubSection.Sequence = currentIndex;
                            formSubSections.Sequence = currentIndex - 1;
                            this.props.callback(this.props.programContainer);
                        }}>Move Subsection Up</button>
                    </div>
                )}
                <div style={{ flex: 1, textAlign: 'center' }}>
                    <button className="ontario-button ontario-button--secondary"

                        onClick={(e) => {
                            let subSectionDialogVisible = [...this.state.subSectionDialogVisible];
                            const sectionIndex = formSection.Sequence - 1;
                            const subSectionIndex = formSubSections.Sequence - 1;
                            if (!subSectionDialogVisible[sectionIndex]) {
                                subSectionDialogVisible[sectionIndex] = [];
                            }
                            subSectionDialogVisible[sectionIndex][subSectionIndex] = true;
                            console.log('subSectionDialogVisible' + subSectionDialogVisible)
                            this.setState({ subSectionDialogVisible: subSectionDialogVisible });
                        }}>Subsection Property</button>
                </div>
                {formSubSections.parent.ListOfFormSubSections.length > 1 && (
                    <div style={{ flex: 1, textAlign: 'right', visibility: formSubSections.Sequence === formSubSections.parent.ListOfFormSubSections.length ? 'hidden' : 'visible' }}>
                        <button className="ontario-button ontario-button--secondary" onClick={(e) => {
                            let currentIndex = formSubSections.Sequence;
                            let nextSubSection = formSubSections.parent.ListOfFormSubSections[currentIndex];
                            nextSubSection.Sequence = nextSubSection.Sequence - 1;
                            formSubSections.Sequence = formSubSections.Sequence + 1;
                            this.props.callback(this.props.programContainer);
                        }}>Move Subsection Down</button>
                    </div>
                )}

                <div style={{ display: this.state.subSectionDialogVisible[formSection.Sequence - 1]?.[formSubSections.Sequence - 1] ? 'block' : 'none' }}>
                    <DialogForSubSectionPropertyComponent key={`dialog_section_${formSection.Sequence - 1}_${formSubSections.Sequence - 1}`} dialogVisible={this.state.subSectionDialogVisible[formSection.Sequence - 1]?.[formSubSections.Sequence - 1]}
                        formSubSections={formSubSections} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                let subSectionDialogVisible = this.state.subSectionDialogVisible;
                                subSectionDialogVisible[formSection.Sequence - 1][formSubSections.Sequence - 1] = false;
                                this.setState({ subSectionDialogVisible: subSectionDialogVisible })
                            }
                            this.props.callback(this.props.programContainer);
                        }}>

                    </DialogForSubSectionPropertyComponent>
                </div>
            </div>
        )

        htmlString.push(
            <div className='ontario-div' style={{ display: 'flex', justifyContent: 'space-between' }} key={"remove_btn_" + formSubSections.Sequence} >
                <div style={{ display: formSection.ENUTitle != null && formSection.ListOfFormSubSections.length == formSubSections.Sequence ? 'block' : 'none' }}>
                    {/* @ts-ignore */}
                    <SplitButton label="Section Options" model={sectionButtons} className="p-button-warning"></SplitButton>
                </div>
                <div style={{ display: formSection.ListOfFormSubSections.length !== formSubSections.Sequence ? 'block' : 'none' }}>
                    {/* @ts-ignore */}
                    <SplitButton label="Sub-Section Options" model={subSectionButtons} className="p-button-warning"></SplitButton>
                </div>
                <div style={{ display: formSection.ListOfFormSubSections.length == formSubSections.Sequence ? 'block' : 'none' }}>
                    {/* @ts-ignore */}
                    <Button onClick={(e) => {
                        let sectionDialogVisible = this.state.sectionDialogVisible;
                        sectionDialogVisible[formSection.Sequence] = true;
                        this.setState({ sectionDialogVisible: sectionDialogVisible });
                    }}>Section Property</Button>
                </div>
                <div style={{ display: formSection.Sequence > 1 && formSection.ListOfFormSubSections.length == formSubSections.Sequence ? 'block' : 'none' }}>
                    {/* @ts-ignore */}
                    <Button onClick={() => {
                        let currentIndex = formSection.Sequence;
                        let lastSection = this.props.programContainer.ListOfFormSections[currentIndex - 2];
                        lastSection.Sequence = currentIndex;
                        formSection.Sequence = currentIndex - 1;
                        this.props.callback(this.props.programContainer);
                    }}>Move Up</Button>
                </div>
                <div style={{ display: formSection.Sequence == this.props.programContainer.ListOfFormSections.length || formSection.ListOfFormSubSections.length != formSubSections.Sequence ? 'none' : 'block' }}>
                    {/* @ts-ignore */}
                    <Button onClick={() => {
                        let currentIndex = formSection.Sequence;
                        let nextSection = this.props.programContainer.ListOfFormSections[currentIndex];
                        nextSection.Sequence = currentIndex;
                        formSection.Sequence = currentIndex + 1;
                        this.props.callback(this.props.programContainer);
                    }}>Move Down</Button>
                </div>
                <div style={{ display: this.state.sectionDialogVisible[formSection.Sequence] ? 'block' : 'none' }}>
                    <DialogForSectionPropertyComponent key={`dialog_section_${formSection.Sequence}`} dialogVisible={this.state.sectionDialogVisible[formSection.Sequence]}
                        formSection={formSection} 
                        isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                let sectionDialogVisible = this.state.sectionDialogVisible;
                                sectionDialogVisible[formSection.Sequence] = false;
                                this.setState({ sectionDialogVisible: sectionDialogVisible })
                            }
                            this.props.callback(this.props.programContainer);
                        }}>

                    </DialogForSectionPropertyComponent>
                </div>


                <div>
                    {/* @ts-ignore */}
                    <Button style={{ cursor: 'pointer' }} onClick={() => {
                        let ele = new FormSectionElements();
                        ele.Sequence = formSubSections.ListOfFormSectionElements.length + 1;
                        ele.Datatype = 'Text';
                        ele.Editable = 'Y';
                        ele.Optional = 'Y';
                        ele.Valid = true;
                        ele.Visible = true;
                        ele.parent = formSubSections;
                        ele.Id = ele.Sequence.toString();//assign Id for comptability


                        // ele.Id = ele.Sequence.toString();//assign Id for comptability
                        // assign Id by searching for element with the highest id +1
                        let maxCurrentID = formSubSections.ListOfFormSectionElements.reduce((acc, currentEle) => acc > Number(currentEle.Id) ? acc : Number(currentEle.Id), 0);
                        ele.Id = (maxCurrentID + 1).toString();

                        formSubSections.ListOfFormSectionElements.push(ele);
                        this.props.callback(this.props.programContainer);
                    }}>Add Element</Button>
                </div>
            </div>
        );

        if (this.state.apiDialogVisible[formSection.Id]) {
            htmlString.push(
                <DialogForAPIComponent section={formSection} dialogVisible={this.state.apiDialogVisible[formSection.Id]} isEng={this.props.isEng}
                    callback={(visible) => {
                        if (visible != null) {
                            const apiDialogVisible = [...this.state.apiDialogVisible];
                            apiDialogVisible[formSection.Id] = false;
                            this.setState({ apiDialogVisible })
                        }
                        this.props.callback(this.props.programContainer);
                    }
                    }>
                </DialogForAPIComponent>)
        }

        if (this.state.sectionImportDialogVisible[formSection.Id]) {
            htmlString.push(
                <div key={`import-dialog-${formSection.Id}`} style={{ 
                    position: 'fixed', 
                    top: 0, 
                    left: 0, 
                    right: 0, 
                    bottom: 0, 
                    backgroundColor: 'rgba(0,0,0,0.5)', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    zIndex: 1000 
                }}>
                    <div style={{ 
                        backgroundColor: 'white', 
                        padding: '20px', 
                        borderRadius: '8px', 
                        minWidth: '400px',
                        maxWidth: '500px'
                    }}>
                        <h3>Import Section from JSON</h3>
                        <p>Select a JSON file to import as a new section after "{formSection.ENUTitle}":</p>
                        {/* @ts-ignore */}
                        <FileUpload 
                            name="sectionImport" 
                            customUpload={true} 
                            auto={true} 
                            multiple={false}
                            maxFileSize={5000000}
                            accept=".json"
                            uploadHandler={(files) => this.importSectionFromJson(files, formSection)}
                            chooseLabel="Choose JSON File"
                            uploadLabel="Import"
                            cancelLabel="Cancel"
                        />
                        <div style={{ marginTop: '15px', textAlign: 'right' }}>
                            {/* @ts-ignore */}
                            <Button 
                                label="Cancel" 
                                className="p-button-secondary"
                                onClick={() => {
                                    const sectionImportDialogVisible = [...this.state.sectionImportDialogVisible];
                                    sectionImportDialogVisible[formSection.Id] = false;
                                    this.setState({ sectionImportDialogVisible });
                                }}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        return htmlString;
    }

    generateElement = (p: FormSectionElements) => {

        let htmlString = [];
        let disabled = false;
        const originalEle=p
        if(p.shareReferenceId){
            const root = getRootComponent(p)
            let refp: FormSectionElements | null = null;
            outer:
            for (const form of root.ListOfFormSections) {
                for (const subForm of form.ListOfFormSubSections) {
                    for (const ele of subForm.ListOfFormSectionElements) {
                        if(ele.sharable&& ele.LoadBindName===p.shareReferenceId){
                            refp = ele;
                            disabled = true;
                            break outer;
                        }

                    }

                }
            }
            if(refp)  p = deepClone(refp)
        }

        htmlString.push(
            this.elementBlock(p,disabled)
        );

        switch (p.Datatype) {
            case 'Label':
                let val = this.props.isEng ? p.Value : p.ValueFRA || "";
                htmlString.push(<div className="card">
                    {p.displayInEditor || <Editor value={val}
                        onTextChange={(e) => {
                            if (this.props.isEng) {
                                if (Utils.willDefaultFR(p.Value, p.ValueFRA)) {
                                    p.ValueFRA = Utils.isNullOrEmpty(e.htmlValue) ? '' : e.htmlValue + FR_SUFFIX;
                                }
                                p.Value = e.htmlValue
                            } else {
                                p.ValueFRA = e.htmlValue;
                            }
                        }}
                        style={{ height: 'auto' }}
                    />
                    }
                    {p.displayInEditor && <InputTextarea value={this.props.isEng ? p.Value : p.ValueFRA} onChange={(e) => {
                        if (this.props.isEng) {
                            if (Utils.willDefaultFR(p.Value, p.ValueFRA)) {
                                p.ValueFRA = Utils.isNullOrEmpty(e.target.value) ? '' : e.target.value + FR_SUFFIX;
                            }
                            p.Value = e.target.value
                        } else {
                            p.ValueFRA = e.target.value
                        }
                        this.props.callback(this.props.programContainer);
                    }} style={{ height: '100px', width: '100%' }} />
                    }
                    <button onClick={() => {
                        p.displayInEditor = !p.displayInEditor;
                        this.props.callback(this.props.programContainer);
                    }} >{p.displayInEditor == true ? "Raw" : "HTML"}</button>
                </div>)
                break;
            case "HTML":
                try {
                    htmlString.push(<div className="card">

                        <div><InputTextarea value={(this.props.isEng ? p.Value : p.ValueFRA) || ''} onChange={(e) => {
                            if (this.props.isEng) {
                                if (Utils.willDefaultFR(p.Value, p.ValueFRA)) {
                                    p.ValueFRA = Utils.isNullOrEmpty(e.target.value) ? '' : e.target.value + FR_SUFFIX;
                                }
                                p.Value = e.target.value
                            } else {
                                p.ValueFRA = e.target.value
                            }
                            this.props.callback(this.props.programContainer);
                        }} style={{ height: '100px', width: '100%' }} />
                        </div>
                    </div>)
                } catch (ex) {
                    console.log(ex);
                }
            case 'InputText':
            case 'InputTextarea':
            case 'PhoneNumber':
            case 'Date':
                break;
            case 'Numberic':
                break;
            case 'Row':
                htmlString.push(
                    <div>
                        {/* @ts-ignore */}
                        <Button style={{ cursor: 'pointer' }} onClick={() => {
                            if (p.subSectionList == null) {
                                let subSection = new FormSubSections();
                                p.subSectionList = [];
                                p.subSectionList.push(subSection);
                                subSection.parent = p;
                                let ele = new FormSectionElements();
                                ele.Sequence = 1;
                                ele.Id = "1";
                                ele.Datatype = 'Text';
                                ele.Editable = 'Y';
                                ele.Optional = 'Y';
                                ele.Valid = true;
                                ele.Visible = true;
                                ele.parent = subSection;
                                subSection.ListOfFormSectionElements = [];
                                subSection.ListOfFormSectionElements.push(ele);
                            } else {
                                const subSection = p.subSectionList[0];
                                let ele = new FormSectionElements();
                                ele.Sequence = subSection.ListOfFormSectionElements.length + 1;
                                ele.Id = (subSection.ListOfFormSectionElements.length + 1).toString();
                                ele.Datatype = 'Text';
                                ele.Editable = 'Y';
                                ele.Optional = 'Y';
                                ele.Valid = true;
                                ele.Visible = true;
                                ele.parent = subSection
                                // ele.Id = (subSection.ListOfFormSectionElements.length+1).toString();
                                // assign Id by searching for element with the highest id +1
                                let maxCurrentID = subSection.ListOfFormSectionElements.reduce((acc, currentEle) => acc > Number(currentEle.Id) ? acc : Number(currentEle.Id), 0);
                                ele.Id = (maxCurrentID + 1).toString();

                                subSection.ListOfFormSectionElements.push(ele);
                            }

                            this.props.callback(this.props.programContainer);
                        }}>Add Element</Button>
                    </div>
                );
                break;
            case 'Currency':
                htmlString.push(
                    <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '5px' }} key={"min_max_" + p.Id}>
                        <div>
                            {/* @ts-ignore */}
                            <InputNumber placeholder={"Min Value"}
                                title={`Min Value`}
                                value={p.MinValue} mode="currency" currency="CAD" locale="en-CA"
                                onChange={(e) => {
                                    p.MinValue = e.value;
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>
                        <div>
                            {/* @ts-ignore */}
                            <InputNumber placeholder={"Max Value"}
                                title={`Max Value`}
                                value={p.MaxValue} mode="currency" currency="CAD" locale="en-CA"
                                onChange={(e) => {
                                    p.MaxValue = e.value;
                                    this.props.callback(this.props.programContainer);
                                }} />
                        </div>
                    </div>
                )
            case 'Checkbox':
                break;
            // case 'SummaryList':
            //     htmlString.push(<SummaryListDesignComponent ele={p} isEng={this.props.isEng}
            //         callback={() => this.props.callback(this.props.programContainer)} />
            //     )
            //     break;  
            case 'CheckGroup':
            case 'RadioButton':
            case 'Dropdown':
                htmlString.push(<DropdownDesignComponent formSection={p.parent.parent} ele={p} isEng={this.props.isEng}
                    callback={() => this.props.callback(this.props.programContainer)} />
                )
                break;
            case 'GroupDropdown':
                htmlString.push(<GroupDropdownDesignComponent formSection={p.parent.parent} ele={p} isEng={this.props.isEng}
                    callback={() => this.props.callback(this.props.programContainer)} />
                )
                break;
            case 'SearchAutocomplete':
                htmlString.push(<SearchAutocompleteDesignComponent formSection={p.parent.parent} ele={p} isEng={this.props.isEng}
                    callback={() => this.props.callback(this.props.programContainer)} />)
                break;
            case 'RadioButtonWithRichText':
            case 'SelectWithRichText':
                htmlString.push(<DropdownWithRichTextDesignComponent formSection={p.parent.parent} field={p} isEng={this.props.isEng}
                    callback={(programContainer: ProgramContainer) => this.props.callback(programContainer)} />
                )
                break;
            case 'Email':
                // htmlString.push(
                //     <div style={{ display: 'flex', justifyContent: 'flex-start', width: '205%', paddingTop: '10px' }} key={"chk_confirmation_" + p.Id}>
                //         <div><label htmlFor={'chk_confirmation_' + p.Id} />&nbsp;Has confirmation Email&nbsp;</div>
                //         <div><Checkbox id={'chk_confirmation_' + p.Id} checked={p.ConfirmationEmail == 'Y'} onChange={(e) => {
                //             e.checked ? p.ConfirmationEmail = 'Y' : p.ConfirmationEmail = 'N'; this.props.callback()
                //         }} ></Checkbox></div>


                //     </div>);
                break;
            case 'Table':
                break;

            case 'TableSummary':
                htmlString.push(
                    <TableSummaryDesignComponent 
                        ele={p} 
                        isEng={this.props.isEng}
                        programContainer={this.props.programContainer}
                        callback={() => this.props.callback(this.props.programContainer)} />
                );
                break;

            case 'TableMenu':
                htmlString.push(
                    <TableMenuDesignComponent ele={p} isEng={this.props.isEng}
                        callback={() => this.props.callback(this.props.programContainer)} />
                );
                break;
            case 'TechError':
                const customText = this.props.isEng ? p.Value : p.ValueFRA || "";
                const content = this.props.isEng ? p.ErrorContentValue : p.ErrorContentValueFRA;
                htmlString.push(<>
                    <div className="card">
                        <div>Error Content</div>

                        <div>
                            {!p.displayInEditor && <Editor value={content} style={{ height: 'auto' }}
                                onTextChange={(e) => {
                                    // Skip callback if value unchanged (prevents loop on Editor init)
                                    const currentVal = this.props.isEng ? p.ErrorContentValue : p.ErrorContentValueFRA;
                                    if (e.htmlValue === currentVal) return;
                                    if (this.props.isEng) {
                                        if (Utils.willDefaultFR(p.ErrorContentValue, p.ErrorContentValueFRA)) {
                                            p.ErrorContentValueFRA = Utils.isNullOrEmpty(e.htmlValue) ? '' : e.htmlValue + FR_SUFFIX;
                                        }
                                        p.ErrorContentValue = e.htmlValue
                                    } else {
                                        p.ErrorContentValueFRA = e.htmlValue;
                                    }
                                    this.props.callback(this.props.programContainer);
                                }} />}
                        </div>

                        <div>
                            {p.displayInEditor && <InputTextarea value={content}
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        if (Utils.willDefaultFR(p.ErrorContentValue, p.ErrorContentValueFRA)) {
                                            p.ErrorContentValueFRA = Utils.isNullOrEmpty(e.target.value) ? '' : e.target.value + FR_SUFFIX;
                                        }
                                        p.ErrorContentValue = e.target.value
                                    } else {
                                        p.ErrorContentValueFRA = e.target.value
                                    }
                                    this.props.callback(this.props.programContainer);
                                }} style={{ height: '100px', width: '100%' }} />}
                        </div>

                        <div>
                            {/* @ts-ignore */}
                            {!p.displayInEditor && <Editor value={customText} style={{ height: 'auto' }}
                                onTextChange={(e) => {
                                    // Skip callback if value unchanged (prevents loop on Editor init)
                                    const currentVal = this.props.isEng ? p.Value : p.ValueFRA;
                                    if (e.htmlValue === currentVal) return;
                                    if (this.props.isEng) {
                                        if (Utils.willDefaultFR(p.Value, p.ValueFRA)) {
                                            p.ValueFRA = Utils.isNullOrEmpty(e.htmlValue) ? '' : e.htmlValue + FR_SUFFIX;
                                        }
                                        p.Value = e.htmlValue
                                    } else {
                                        p.ValueFRA = e.htmlValue;
                                    }
                                    this.props.callback(this.props.programContainer);
                                }}
                            />}
                        </div>
                        <div>
                            {p.displayInEditor && <InputTextarea value={customText} onChange={(e) => {
                                this.props.isEng ? p.Value = e.target.value : p.ValueFRA = e.target.value
                                this.props.callback(this.props.programContainer);
                            }} style={{ height: '100px', width: '100%' }} />}
                        </div>
                        <button onClick={() => {
                            p.displayInEditor = !p.displayInEditor;
                            this.props.callback(this.props.programContainer);
                        }} >{p.displayInEditor == true ? "Raw" : "HTML"}</button>
                    </div>
                </>)
                break;
            case "SummaryList":
            case 'Excel Template':
                htmlString.push(<TableComponent ele={p} isEng={this.props.isEng}
                    callback={(dialogVisible) => {
                        if (dialogVisible != null) {
                            this.setState({ dialogVisible: dialogVisible });
                        }
                        this.props.callback(this.props.programContainer);
                    }
                    } />);
                break;

            case 'Download':
                const downloadMaxSize = (p.DownloadMaxFileSize || 5) * 1000000; // Default 5MB
                htmlString.push(
                    <div style={{ marginTop: '5%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                            <label style={{ marginRight: '10px' }}>Max File Size (MB):</label>
                            <InputText
                                className="ontario-input"
                                style={{ width: '80px' }}
                                value={p.DownloadMaxFileSize?.toString() || '5'}
                                placeholder="5"
                                onChange={(e) => {
                                    const value = Number(e.target.value);
                                    if (!isNaN(value) || e.target.value === '') {
                                        p.DownloadMaxFileSize = e.target.value === '' ? 5 : value;
                                        this.props.callback(this.props.programContainer);
                                    }
                                }}
                            />
                        </div>
                        {/* @ts-ignore */}
                        <FileUpload name="attachment[]" customUpload={true} maxFileSize={downloadMaxSize} onRemove={this.fileDownloadHandler.bind(this, p)} auto={true} uploadHandler={this.fileDownloadHandler.bind(this, p)} />
                    </div>
                );
                break;
            case 'Image':
                htmlString.push(
                    <div style={{ marginTop: '5%' }}>
                        {/* @ts-ignore */}
                        <FileUpload name="attachment[]" customUpload={true} maxFileSize={5000000} onRemove={this.fileDownloadHandler.bind(this, p)} auto={true} uploadHandler={this.fileDownloadHandler.bind(this, p)} />
                    </div>
                );
                break;

            case 'InformationAlert':
            case 'WarningAlert':
            case 'SuccessAlert':
            case 'ErrorAlert':
                htmlString.push(
                    <div style={{ width: '100%', paddingTop: '10px' }} >
                        <div style={{ paddingRight: '5px' }}>
                            <InputText className='ontario-input' placeholder='Title' title="Title"
                                value={this.props.isEng ? p.MessageTitle : p.MessageTitleFRA}
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        if (Utils.willDefaultFR(p.MessageTitle, p.MessageTitleFRA)) {
                                            p.MessageTitleFRA = Utils.isNullOrEmpty(e.target.value) ? '' : e.target.value + FR_SUFFIX;
                                        }
                                        p.MessageTitle = e.target.value;
                                    } else {
                                        p.MessageTitleFRA = e.target.value;
                                    }

                                    this.props.callback(this.props.programContainer);
                                }}
                            />
                        </div>

                        <div style={{ paddingRight: '5px' }}>
                            {/* @ts-ignore */}
                            {!p.displayInEditor && (
                                <Editor className='ontario-input ontario-margin-bottom-0-!'
                                    placeholder='Message Body' title="Message Body"
                                    value={this.props.isEng ? p.MessageBody : p.MessageBodyFRA}
                                    onTextChange={(e) => {
                                        if (this.props.isEng) {
                                            if (Utils.willDefaultFR(p.MessageBody, p.MessageBodyFRA)) {
                                                p.MessageBodyFRA = Utils.isNullOrEmpty(e.htmlValue) ? '' : e.htmlValue + FR_SUFFIX;
                                            }
                                            p.MessageBody = e.htmlValue;
                                        } else {
                                            p.MessageBodyFRA = e.htmlValue;
                                        }
                                        this.props.callback(this.props.programContainer);
                                    }} />
                            )}
                            {p.displayInEditor && (
                                <InputTextarea value={this.props.isEng ? p.MessageBody : p.MessageBodyFRA}
                                    onChange={(e) => {
                                        if (this.props.isEng) {
                                            if (Utils.willDefaultFR(p.MessageBody, p.MessageBodyFRA)) {
                                                p.MessageBodyFRA = Utils.isNullOrEmpty(e.target.value) ? '' : e.target.value + FR_SUFFIX;
                                            }
                                            p.MessageBody = e.target.value;
                                        } else {
                                            p.MessageBodyFRA = e.target.value;
                                        }
                                        this.props.callback(this.props.programContainer);
                                    }}
                                    style={{ height: '100px', width: '100%' }}
                                />
                            )}
                            <button onClick={() => {
                                p.displayInEditor = !p.displayInEditor;
                                this.props.callback(this.props.programContainer);
                            }}>
                                {p.displayInEditor == true ? "Raw" : "HTML"}
                            </button>
                        </div>
                        {(p.Datatype === 'SuccessAlert' || p.Datatype === 'WarningAlert' || p.Datatype === 'ErrorAlert' || p.Datatype === 'InformationAlert') && (
                            <div style={{ paddingRight: '5px', marginTop: '10px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '8px' }}>
                                    <Checkbox
                                        inputId={`fadeout_cb_${p.Sequence}`}
                                        checked={p.FadeOut ?? false}
                                        onChange={(e) => {
                                            p.FadeOut = e.checked;
                                            if (!e.checked) p.FadeOutSeconds = 0;
                                            this.props.callback(this.props.programContainer);
                                        }}
                                    />
                                    <label htmlFor={`fadeout_cb_${p.Sequence}`} style={{ cursor: 'pointer' }}>
                                        Fade out
                                    </label>
                                </div>
                                {p.FadeOut && (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                        <label htmlFor={`fadeout_sec_${p.Sequence}`} style={{ whiteSpace: 'nowrap' }}>
                                            Fade out after (seconds, 0 = no fade out):
                                        </label>
                                        <InputNumber
                                            inputId={`fadeout_sec_${p.Sequence}`}
                                            value={p.FadeOutSeconds ?? 0}
                                            min={0}
                                            step={1}
                                            showButtons
                                            style={{ width: '120px' }}
                                            onValueChange={(e) => {
                                                p.FadeOutSeconds = e.value ?? 0;
                                                this.props.callback(this.props.programContainer);
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                );
                break;
            case 'GoogleLookUpAddress':
                htmlString.push(<div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>Unit Number</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["unitNumber"]} onChange={e => {
                                p["unitNumber"] = e.target.value.split(" ").join("__");
                                this.props.callback(this.props.programContainer);
                            }}></InputText>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>Street Number</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["streetNumber"]} onChange={e => {
                                p["streetNumber"] = e.target.value.split(" ").join("__");;
                                this.props.callback(this.props.programContainer);
                            }}></InputText>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>Street Name</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["streetName"]} onChange={e => {
                                p["streetName"] = e.target.value.split(" ").join("__");;
                                this.props.callback(this.props.programContainer);
                            }}></InputText>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>Street Type</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["streetType"]} onChange={e => {
                                p["streetType"] = e.target.value.split(" ").join("__");;
                                this.props.callback(this.props.programContainer);
                            }}></InputText>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>Street Direction</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["streetDirection"]} onChange={e => {
                                p["streetDirection"] = e.target.value.split(" ").join("__");;
                                this.props.callback(this.props.programContainer);
                            }}></InputText>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>P.O. Box</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["POBox"]} onChange={e => {
                                p["POBox"] = e.target.value.split(" ").join("__");;
                                this.props.callback(this.props.programContainer);
                            }}></InputText>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>City/town</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["city"]} onChange={e => {
                                p["city"] = e.target.value.split(" ").join("__");;
                                this.props.callback(this.props.programContainer);
                            }}></InputText>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>Province</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["province"]} onChange={e => {
                                p["province"] = e.target.value.split(" ").join("__");;
                                this.props.callback(this.props.programContainer);
                            }}></InputText>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                        <div style={{ width: '20%', paddingRight: '5px' }}>Postal Code</div>
                        <div>
                            <InputText className='ontario-input' placeholder='Binding field' value={p["postalCode"]} onChange={e => {
                                p["postalCode"] = e.target.value.split(" ").join("__");;
                                this.props.callback(this.props.programContainer);
                            }}></InputText>
                        </div>

                    </div>
                </div>
                );
                break;
            case 'HTMLTemplate':
                break;
            case 'StartRating':
                htmlString.push(
                    <StarRating
                        title={this.props.isEng ? p.ENUTitle : p.FRATitle}
                        isEng={this.props.isEng}
                        field={p}
                        callbackElement={p => this.props.callback(p)}
                    />
                );
                break;
            case 'QRCode':
                //const env = process.env.ENV || 'dev';
                const url = EnvBaseUrl.prod + '/' + this.props.programContainer.CategoryId;
                htmlString.push(
                    <QRCodeComponent value={url} size={100} />
                );
                break;
            case 'Accordions':
                const setAccordions = (accordions: AccordionData[], expandAll = false) => {
                    if (this.props.isEng) {
                        p.accordions = { expandAll: expandAll, accordions: accordions };
                    } else {
                        p.accordionsFRA = { expandAll: expandAll, accordions: accordions };
                    }
                    this.props.callback(getRootComponent(p));
                }
                htmlString.push(
                    <AccordionsDesignComponent
                        field={p}
                        isEng={this.props.isEng}
                        setAccordion={setAccordions}
                        callBackElement={p => this.props.callback(p)}
                    />
                );
                break;
            case 'RecaptchaButton':
                htmlString.push(
                    <div style={{ width: '100%', padding: '0.5rem', border: '1px solid', marginTop: '1rem' }} >
                        <div className="ontario-margin-top-12-!" style={{ display: 'flex', alignItems: 'center' }}>
                            <label htmlFor={`recaptcha_api_${p.Id}`} style={{ width: '12rem' }}>API: </label>
                            <InputText id={`recaptcha_api_${p.Id}`} className='ontario-input' placeholder='API' title="API"
                                value={p.Recaptcha?.api}
                                onChange={(e) => {
                                    if (!p.Recaptcha) {
                                        p.Recaptcha = { content: { en: '', fr: '' }, action: '', handlerName: '' };
                                    }
                                    p.Recaptcha.api = e.target.value;
                                    this.props.callback(this.props.programContainer);
                                }}
                            />
                        </div>
                        <div className="ontario-margin-top-12-!" style={{ display: 'flex', alignItems: 'center' }}>
                            <label htmlFor={`recaptcha_action_${p.Id}`} style={{ width: '12rem' }}>Action: </label>
                            <InputText id={`recaptcha_action_${p.Id}`} className='ontario-input' placeholder='Recaptcha Action' title="Action"
                                value={p.Recaptcha?.action}
                                onChange={(e) => {
                                    if (!p.Recaptcha) {
                                        p.Recaptcha = { content: { en: '', fr: '' }, action: '', handlerName: '' };
                                    }
                                    p.Recaptcha.action = e.target.value;
                                    this.props.callback(this.props.programContainer);
                                }}
                            />
                        </div>
                        <div className="ontario-margin-top-12-!" style={{ display: 'flex', alignItems: 'center' }}>
                            <label htmlFor={`recaptcha_handler_name_${p.Id}`} style={{ width: '12rem' }}>Hanlder name: </label>
                            <InputText id={`recaptcha_handler_name_${p.Id}`} className='ontario-input' placeholder='Recaptcha handler name' title="Handler name"
                                value={p.Recaptcha?.handlerName}
                                onChange={(e) => {
                                    if (!p.Recaptcha) {
                                        p.Recaptcha = { content: { en: '', fr: '' }, action: '', handlerName: '' };
                                    }
                                    p.Recaptcha.handlerName = e.target.value;
                                    this.props.callback(this.props.programContainer);
                                }}
                            />
                        </div>
                        <div className="ontario-margin-top-12-!">
                            <label htmlFor={`recaptcha_content_${p.Id}`} style={{ marginBottom: '0.5rem' }}>Recaptcha content: </label>
                            <div className="card">
                                {p.displayInEditor || (
                                    <>
                                        {/* @ts-ignore */}
                                        <Editor id={`recaptcha_content_${p.Id}`}
                                            placeholder='Recatcha button title' title="Recaptcha Submit" style={{ height: 'auto' }}
                                            value={this.props.isEng ? p.Recaptcha?.content.en : p.Recaptcha?.content.fr}
                                            onTextChange={(e) => {
                                                const lang = this.props.isEng ? 'en' : 'fr';
                                                p.Recaptcha = {
                                                    ...p.Recaptcha ?? { action: '', handlerName: '' },
                                                    content: { ...p.Recaptcha?.content ?? {}, [lang]: e.htmlValue },
                                                };
                                                this.props.callback(this.props.programContainer);
                                            }} />
                                    </>
                                )}
                                {p.displayInEditor && (
                                    <InputTextarea id={`recaptcha_content_${p.Id}`}
                                        style={{ height: '100px', width: '100%' }}
                                        value={this.props.isEng ? p.Recaptcha?.content.en : p.Recaptcha?.content.fr}
                                        onChange={(e) => {
                                            const lang = this.props.isEng ? 'en' : 'fr';
                                            p.Recaptcha = {
                                                ...p.Recaptcha ?? { action: '', handlerName: '' },
                                                content: { ...p.Recaptcha?.content ?? {}, [lang]: e.target.value },
                                            };
                                            this.props.callback(this.props.programContainer);
                                        }} />
                                )}
                                <button
                                    onClick={() => {
                                        p.displayInEditor = !p.displayInEditor;
                                        this.props.callback(this.props.programContainer);
                                    }} >
                                    {p.displayInEditor == true ? "Raw" : "HTML"}
                                </button>
                            </div>
                        </div>
                    </div>
                );
                break;
            // case 'Card':
            //     htmlString.push(<DialogCardDesignComponent ele={p} isEng={this.props.isEng} dialogVisible={this.state.dialogVisible}
            //           callback={(dialogVisible) => {
            //             if (dialogVisible != null) {
            //                 this.setState({ dialogVisible: dialogVisible });
            //             }
            //             this.props.callback( this.props.programContainer);
            //         }
            //         } />);
            // break;
        }

        htmlString.push(<MoreButtonComponent ele={originalEle} isEng={this.props.isEng} callback={() => this.props.callback(this.props.programContainer)} />);

        return htmlString;
    }

    elementBlock = (p: FormSectionElements, disabled?: boolean) => {
        let html = [];
        let subHtml = [];
        if (p.richTextChecked) {
            subHtml.push(<div style={{ width: '50%', paddingRight: '5px' }}>
                {/* @ts-ignore */}
                <Editor className='ontario-input' placeholder={this.props.isEng ? `Element label (Required)` : 'French Element label (Required)'}
                    title={this.props.isEng ? `Element label (Required)` : 'French Element label (Required)'} required
                    value={(this.props.isEng ? p.ENUTitle : p.FRATitle) || ''} disabled ={disabled}
                    onTextChange={(e) => {
                        if (this.props.isEng) {
                            if (Utils.willDefaultFR(p.ENUTitle, p.FRATitle)) {
                                p.FRATitle = Utils.isNullOrEmpty(e.htmlValue) ? '' : e.htmlValue + FR_SUFFIX;
                            }
                            p.ENUTitle = e.htmlValue;
                            if (Utils.isNullOrEmpty(findDependency(this.props.programContainer, p.LoadBindName))) {
                                p.LoadBindName = p.ENUTitle?.replace(/<[^>]+>/g, "").split(" ").join("__");
                            }
                        } else {
                            p.FRATitle = e.htmlValue;
                        }
                        //const textOnly = e.htmlValue.replace(/<[^>]+>/g, "");
                        //p.LoadBindName = textOnly.split(" ").join("__");

                        this.props.callback(this.props.programContainer);
                    }} />
            </div>
            )
        } else {
           subHtml.push(<div style={{ width: '50%', paddingRight: '5px' }}>
                <InputText className='ontario-input' placeholder={this.props.isEng ? `Element label (Required)` : 'French Element label (Required)'}
                    title={this.props.isEng ? `Element label (Required)` : 'French Element label (Required)'} required
                    value={(this.props.isEng ? p.ENUTitle : p.FRATitle) || ''} disabled ={disabled}
                    onChange={(e) => {
                        if (this.props.isEng) {
                            if (Utils.willDefaultFR(p.ENUTitle, p.FRATitle)) {
                                p.FRATitle = Utils.isNullOrEmpty(e.target.value) ? '' : e.target.value + FR_SUFFIX;
                            }
                            p.ENUTitle = e.target.value;
                            if (Utils.isNullOrEmpty(findDependency(this.props.programContainer, p.LoadBindName)) && (!p.LoadBindName || p.LoadBindName?.length<6)) {
                                p.LoadBindName = p.ENUTitle?.split(" ").join("__");
                            }
                        }
                        else {
                            p.FRATitle = e.target.value;
                        }
                        this.props.callback(this.props.programContainer);
                    }} />
            </div>)
        }

        html.push(<div key={p.parent.Id + "_element_" + p.Sequence?.toString()} >
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', paddingTop: '10px' }} >
                {subHtml}
                <div style={{ display: 'flex', justifyContent: 'flex-start', width: '20%', paddingLeft: '5px' }} key={"chk_" + p.Id}>
                    <div><label htmlFor={'chk_' + p.Id} />&nbsp;Required&nbsp;</div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_' + p.Id} disabled={disabled||this.props.isEng == false} checked={p.Optional == 'N'}
                            onChange={(e) => {
                                if (e.checked) {
                                    p.Optional = 'N';
                                    p.EmptyErrorMessage = '{0} is a mandatory field';
                                    p.EmptyErrorMessageFRA = '{0} est un champ obligatoire.';
                                } else {
                                    p.Optional = 'Y';
                                    delete p.EmptyErrorMessage;
                                    delete p.EmptyErrorMessageFRA;
                                }
                                this.props.callback(this.props.programContainer)
                            }}>
                        </Checkbox>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-start', width: '25%', paddingLeft: '5px' }} key={"chk_readonly_" + p.Id}>
                    <div><label htmlFor={'chk_readonly_' + p.Id} />&nbsp;Read Only&nbsp;</div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_readonly_' + p.Id} disabled={disabled||this.props.isEng == false} checked={p.ReadOnly} onChange={(e) => {
                            p.ReadOnly = e.checked; this.props.callback(this.props.programContainer)
                        }}></Checkbox>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-start', width: '10%', paddingLeft: '5px' }} key={"chk_readonly_richtext" + p.Id}>
                    <div><label htmlFor={'chk_richtext' + p.Id + p.Sequence?.toString()} />Rich Text&nbsp;</div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_richtext' + p.Id + p.Sequence?.toString()} disabled={disabled||this.props.isEng == false}
                            checked={p.richTextChecked} 
                            onChange={(e) => {
                                p.richTextChecked = e.checked;
                                this.props.callback(this.props.programContainer)
                            }}>
                        </Checkbox>
                    </div>
                </div>
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', paddingTop: '10px' }} >
                <div style={{ width: '50%', paddingRight: '5px' }}>
                    <InputText className='ontario-input' disabled={disabled||this.props.isEng == false} placeholder='Binding field name' title="Binding field name" value={p.LoadBindName} 
                    onChange={(e) => {
                        let message = findDependency(this.props.programContainer, p.LoadBindName)
                            p.LoadBindName = e.target.value;
                            this.props.callback(this.props.programContainer);
                        

                    }} />
                </div>
                <div style={{ width: '90%', display: 'flex' }}>
                    <div style={{ width: '50%', paddingLeft: '5px' }} >
                        {/* @ts-ignore */}
                        <Dropdown title="Field type"
                            disabled={disabled||this.props.isEng == false}
                            optionLabel="label"
                            optionValue='val'
                            options={'Row' === p.parent.parent.Datatype ? elementTypeList.filter(item => item.val !== 'Row') : elementTypeList}
                            value={p.Datatype}
                            onChange={(e) => {
                               
                                    p.Datatype = e.value;
                                    this.props.callback(this.props.programContainer);
                               
                            }}
                        />
                    </div>
                    {p?.Datatype === 'CheckGroup' && (<div style={{ display: 'flex', justifyContent: 'flex-start', width: '10%', paddingLeft: '5px' }} key={"chk_readonly_multipleChoiceWithRichText" + p.Id}>
                        <div><label htmlFor={'chk_multipleChoiceWithRichText' + p.Id + p.Sequence?.toString()} />With Rich Text&nbsp;</div>
                        <Checkbox id={'chk_multipleChoiceWithRichText' + p.Id + p.Sequence?.toString()} disabled={disabled||this.props.isEng == false}
                            checked={p.displayAsRichText}
                            onChange={(e) => {
                                p.displayAsRichText = e.checked;
                                this.props.callback(this.props.programContainer)
                            }}>
                        </Checkbox>
                    </div>)}
                </div>
                 <div style={{ display: p.Datatype == 'Dropdown' ? "flex" : "none", justifyContent: 'flex-start', width: '35%', paddingLeft: '5px' }}>
                    <div><label htmlFor={'chk_sort_' + p.Id} />&nbsp;Sort&nbsp;</div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_sort_' + p.Id} disabled={disabled||this.props.isEng == false} checked={p.Sort} onChange={(e) => {
                            p.Sort = e.checked; this.props.callback(this.props.programContainer)
                        }}></Checkbox>
                    </div>
                </div>
                <div style={{ display: p.Datatype == 'Dropdown' ? "flex" : "none", width: '25%', justifyContent: 'flex-start', paddingLeft: '5px' }}>
                    <div><label htmlFor={'chk_readonly_' + p.AddEmptyItemToList} />&nbsp;Add empty option&nbsp;</div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_readonly_' + p.AddEmptyItemToList} disabled={disabled||this.props.isEng == false} checked={p.AddEmptyItemToList == 'Y'}
                            onChange={(e) => {
                                e.checked ? p.AddEmptyItemToList = 'Y' : p.AddEmptyItemToList = 'N';
                                this.props.callback(this.props.programContainer);
                            }}>
                        </Checkbox>
                    </div>
                </div>

                <div style={{ display: p.Datatype == 'Row' ? "flex" : "none", justifyContent: 'flex-start', paddingRight: '5px' }}>
                    <div><label htmlFor={'chk_readonly_' + p.AddEmptyItemToList} />Gap</div>
                    <div style={{ paddingRight: '5px', }}>
                        <InputText className='ontario-input' disabled={disabled||this.props.isEng == false} placeholder='Gap in px' title="gap between controls in the same row" value={p.Gap}
                            onChange={(e) => {
                                p.Gap = e.target.value;
                                this.props.callback(this.props.programContainer);
                            }} />
                    </div>
                </div>
                <div style={{ display: p.Datatype == 'CheckGroup' ? "flex" : "none", width: '25%', justifyContent: 'flex-start', paddingRight: '5px' }}>
                    <div><label htmlFor={'chk_readonly_' + p.Single} />&nbsp;Single&nbsp;</div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_readonly_' + p.Single} disabled={disabled||this.props.isEng == false} checked={p.Single == 'Y'}
                            onChange={(e) => {
                                e.checked ? p.Single = 'Y' : delete p.Single;
                                this.props.callback(this.props.programContainer);
                            }}>
                        </Checkbox>
                    </div>
                    <div><label htmlFor={'chk_readonly_' + p.Horizontal} />&nbsp;&nbsp;&nbsp;Horizontal&nbsp;</div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_readonly_' + p.Horizontal} disabled={disabled||this.props.isEng == false} checked={p.Horizontal == 'Y'}
                            onChange={(e) => {
                                e.checked ? p.Horizontal = 'Y' : delete p.Horizontal;
                                this.props.callback(this.props.programContainer);
                            }}>
                        </Checkbox>
                    </div>
                </div>

                <div style={{ display: p.Datatype == 'RadioButton' ? "flex" : "none", width: '25%', justifyContent: 'flex-start', paddingRight: '5px' }}>
                    <div><label htmlFor={'chk_readonly_' + p.Horizontal} />&nbsp;&nbsp;&nbsp;Horizontal&nbsp;</div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_readonly_' + p.Horizontal} disabled={disabled||this.props.isEng == false} checked={p.Horizontal == 'Y'}
                            onChange={(e) => {
                                e.checked ? p.Horizontal = 'Y' : delete p.Horizontal;
                                this.props.callback(this.props.programContainer);
                            }}>
                        </Checkbox>
                    </div>
                </div>
            </div>

        </div>);

        const rowHtml = this.generateRowHtml(p)

        html.push(rowHtml);

        return html;
    }

    generateRowHtml = (p: FormSectionElements) => {
        let rowHtml = [];
        if (p.Datatype == "Row") {
            if (p.subSectionList != null) {
                p.subSectionList[0]?.ListOfFormSectionElements.sort((a, b) => a.Sequence - b.Sequence).forEach(q => {
                    rowHtml.push(<p>
                        {this.generateElement(q)}
                    </p>
                    );
                })
            }

            return rowHtml.length > 0 ?
                <div >
                    <Panel >{rowHtml}</Panel>
                </div>
                : null;
        }
        return null;

    }

    generateHeader = (formSection: FormSections) => {

        let titleVal = this.props.isEng ? formSection.ENUTitle : formSection.FRATitle;;
        let descriptionVal = this.props.isEng ? formSection.ENUDescription : formSection.FRADescription;
        const divStyle = {
            backgroundColor: '#BBBBBB', // Specify the desired background color
            padding: '10px',
            marginBottom: '10px',
        };

        return (
            <div>

                <div style={{ display: 'flex', width: '100%', paddingTop: '10px' }}>
                     <InputText placeholder="Section Title" title="Section Title" className="ontario-input" style={{ width: '100%', }}
                        value={titleVal || ''} onChange={(e) => {
                            if (this.props.isEng) {
                                formSection.ENUTitle = e.target.value;
                            } else {
                                formSection.FRATitle = e.target.value;
                            }
                            this.props.callback(this.props.programContainer);
                        }} />
    
               
                    <div style={{ marginLeft: '10px' }}><label htmlFor={'chk_formSection_richtext' + formSection.Id + formSection.Sequence?.toString()} />Screen Read Only</div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_formSection_richtext' + formSection.Id + formSection.Sequence?.toString()}
                            disabled={this.props.isEng == false}
                            checked={formSection.srOnly}
                            onChange={(e) => {
                                formSection.srOnly = e.checked;
                                this.props.callback(this.props.programContainer)
                            }}>
                        </Checkbox>
                    </div>
           
                </div>

                <div style={{ width: '100%', paddingTop: '10px' }}>
                    <InputTextarea placeholder="Additional Description/Instructions" title="Additional Description/Instructions" className="ontario-input"
                        value={descriptionVal || ''} onChange={(e) => {
                            if (this.props.isEng) {
                                if (Utils.willDefaultFR(formSection.ENUDescription, formSection.FRADescription)) {
                                    formSection.FRADescription = Utils.isNullOrEmpty(e.target.value) ? '' : e.target.value + FR_SUFFIX;
                                }
                                formSection.ENUDescription = e.target.value;
                            } else {
                                formSection.FRADescription = e.target.value;
                            }
                            this.props.callback(this.props.programContainer);
                        }}
                    />
                </div>
                {/* <div style={{ width: '100%', paddingTop: '10px' }}>
                    <InputText placeholder="Business Entity" title="Business Entity" className="ontario-input" style={{ width: '100%', }}
                        value={formSection.EntityName} onChange={(e) => {
                            formSection.EntityName = e.target.value;
                            this.props.callback();
                        }} />
                </div> */}
                <div style={{ display: 'flex', paddingTop: '10px' }}>
                    {/* when stepper is selected */}
                    {this.props.programContainer.displayForm !== 'NoIndicatorStepper' && (
                        <>
                            <div>
                                {/* @ts-ignore */}
                                <Checkbox id={'chk_section_IsStepper' + formSection.Id} key={'chk_section_IsStepper' + formSection.Id} checked={formSection.NotStep} onChange={(e) => {
                                    formSection.NotStep = e.checked;
                                    this.props.callback(this.props.programContainer);
                                }} ></Checkbox>
                            </div>
                            <div style={{ paddingLeft: '3px' }}>
                                <label htmlFor={'chk_section_IsStepper' + formSection.Id} className="p-checkbox-label">Not a Step</label>
                            </div>
                            <div>
                                {/* @ts-ignore */}
                                <Checkbox id={'chk_section_NoStepIndicator' + formSection.Id} key={'chk_section_NoStepIndicator' + formSection.Id} checked={formSection.NoStepIndicator} onChange={(e) => {
                                    formSection.NoStepIndicator = e.checked;
                                    this.props.callback(this.props.programContainer);
                                }} ></Checkbox>
                            </div>
                            <div style={{ paddingLeft: '3px' }}>
                                <label htmlFor={'chk_section_NoStepIndicator' + formSection.Id} className="p-checkbox-label">No Step Indicator</label>
                            </div>
                        </>
                    )}

                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_section_' + formSection.Id} checked={formSection.CustomizedReviewPage} onChange={(e) => {
                            formSection.CustomizedReviewPage = e.checked
                            this.props.callback(this.props.programContainer);
                        }} ></Checkbox>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <label htmlFor={'chk_section_' + formSection.Id} className="p-checkbox-label">Customized Review Page</label>
                    </div>

                    {formSection?.CustomizedReviewPage && (
                        <>
                            <div>
                                {/* @ts-ignore */}
                                <Checkbox id={'chk_section_order' + formSection.Id}
                                          checked={formSection.followSubSectionOrder} onChange={(e) => {
                                    formSection.followSubSectionOrder = e.checked
                                    this.props.callback(this.props.programContainer);
                                }}></Checkbox>
                            </div>
                            <div style={{paddingLeft: '3px'}}>
                                <label htmlFor={'chk_section_order' + formSection.Id} className="p-checkbox-label">Follow
                                    Subsection
                                    order</label>
                            </div>
                        </>
                    )}

                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_section_tech_error' + formSection.Id} checked={formSection.IsTechErrorPage} onChange={(e) => {
                            formSection.IsTechErrorPage = e.checked
                            this.props.callback(this.props.programContainer);
                        }} ></Checkbox>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <label htmlFor={'chk_section_' + formSection.Id} className="p-checkbox-label">Is Tech Error Page</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_No_Total_Number_Pages' + formSection.Id} checked={formSection.NoTotalPages} onChange={(e) => {
                            formSection.NoTotalPages = e.checked;
                            formSection.Visible = false;
                            this.props.callback(this.props.programContainer);
                        }} ></Checkbox>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <label htmlFor={'chk_section_' + formSection.Id} className="p-checkbox-label">No Total Number of Pages</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_Info Page' + formSection.Id} checked={formSection.IsInfoPage} onChange={(e) => {
                            formSection.IsInfoPage = e.checked
                            this.props.callback(this.props.programContainer);
                        }} ></Checkbox>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <label htmlFor={'chk_section_' + formSection.Id} className="p-checkbox-label">Info Page</label>
                    </div>

                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_confoirmation_Page' + formSection.Id} checked={formSection.IsConfirmationPage} onChange={(e) => {
                            formSection.IsConfirmationPage = e.checked
                            this.props.callback(this.props.programContainer);
                        }} ></Checkbox>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <label htmlFor={'chk_section_' + formSection.Id} className="p-checkbox-label">Confirmation Page</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_title_in_step_' + formSection.Id} checked={formSection.TitleInStepIndicator} onChange={(e) => {
                            formSection.TitleInStepIndicator = e.checked
                            this.props.callback(this.props.programContainer);
                        }} ></Checkbox>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <label htmlFor={'chk_section_' + formSection.Id} className="p-checkbox-label">Title displayed in Step Indicator</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox id={'chk_hide_title_' + formSection.Id} checked={formSection.setHideTitle} onChange={(e) => {
                            formSection.setHideTitle = e.checked
                            this.props.callback(this.props.programContainer);
                        }} ></Checkbox>
                    </div>
                    <div style={{ paddingLeft: '3px' }}>
                        <label htmlFor={'chk_hide_title_' + formSection.Id} className="p-checkbox-label">Hide Page Title</label>
                    </div>
                </div>

                {/* {this.props.programContainer.displayForm !== 'NoIndicatorStepper' && this.props.programContainer.displayForm !== 'progressBarStepper' && !formSection.NotStep && (
                    <div className="ontario-margin-top-12-!">
                        <InputTextarea placeholder="Step title" title="step title" className="ontario-input"
                            value={formSection.stepTitle} onChange={(e) => {
                                if (this.props.isEng)
                                    formSection.stepTitle = e.target.value;
                                else
                                    formSection.stepTitleFRA = e.target.value;
                                this.props.callback( this.props.programContainer);
                            }}
                        />
                    </div>
                )} */}

                {formSection?.CustomizedReviewPage && (
                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', marginTop: '8px' }}>
                        <div style={{ width: '14%' }}>Summary Buttons Top Gap:</div>
                        <div style={{ flex: 1 }}>
                            <InputText
                                placeholder="e.g. 1rem, 16px"
                                className="ontario-input"
                                value={formSection.CustomizedSummaryProps?.buttonTopGap || ''}
                                onChange={(e) => {
                                    formSection.CustomizedSummaryProps = formSection.CustomizedSummaryProps || {};
                                    formSection.CustomizedSummaryProps.buttonTopGap = e.target.value;
                                    this.props.callback(this.props.programContainer);
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }

    fileDownloadHandler = async (p, files) => {
        let worksheetNames = [];
        let attachment = {
            content: null,
            fileName: null,
            fileType: null
        }

        for (const file of files.files) {
            var reader = new FileReader();
            const readFile = () => {
                return new Promise<void>((resolve, reject) => {
                    reader.readAsDataURL(file);
                    reader.onload = function (e) {
                        attachment.content = reader.result;
                        attachment.fileName = file.name;
                        attachment.fileType = file.type;
                        resolve();
                    }

                    reader.onerror = function (e) {
                        reject(e);
                    };
                })
            }
            await readFile();
        }

        p.Value = attachment;

    };

    generateFileValue(p) {
        p.Value = this.attachment;
        const divStyle = {
            backgroundColor: '#CCCCCC', // Specify the desired background color
            padding: '10px',
            marginBottom: '10px',
        };

        const divElement = document.createElement('div');
        Object.assign(divElement.style, divStyle);
    }

    fileUploader = (e) => {
        if (!e.files) return;

        e.files.forEach(element => {
            var reader = new FileReader();
            reader.onload = () => {
                if (this.props.isEng) {
                    this.props.programContainer.pdfTemplate = this.convertArrayBufferToString(reader.result);
                } else {
                    this.props.programContainer.pdfTemplateFRA = this.convertArrayBufferToString(reader.result);
                }

                PdfUtils.generateProgramContainer(this.props.programContainer).then(programContainer => {
                    // this.props.callback(programContainer);
                })
            }

            reader.readAsDataURL(element);
        });
    };

    convertArrayBufferToString = (input: string | ArrayBuffer) => {
        if (typeof input == 'string') {
            return input;
        } else {
            const textDecoder = new TextDecoder('utf-8'); // 'utf-8' is the most common encoding
            const text = textDecoder.decode(input);
            return text;
        }
    }

    exportSectionAsJson = (formSection: FormSections) => {
        try {
            const sectionCopy = deepClone(formSection);
            this.cleanParentReferences(sectionCopy);
            
            const jsonString = stringifyJson(sectionCopy, this.props.programContainer.CategoryId);
            const blob = new Blob([jsonString], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
            
            const link = document.createElement('a');
            link.href = url;
            link.download = `section-${formSection.ENUTitle || formSection.Id}-export.json`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            
            this.growl.show({ 
                severity: 'success', 
                summary: 'Export Successful', 
                detail: `Section "${formSection.ENUTitle || formSection.Id}" exported successfully` 
            });
        } catch (error) {
            console.error('Error exporting section:', error);
            this.growl.show({ 
                severity: 'error', 
                summary: 'Export Failed', 
                detail: 'Failed to export section as JSON' 
            });
        }
    }

    cleanParentReferences = (obj: any) => {
        if (obj && typeof obj === 'object') {
            if (obj.parent) {
                delete obj.parent;
            }
            if (Array.isArray(obj)) {
                obj.forEach(item => this.cleanParentReferences(item));
            } else {
                Object.values(obj).forEach(value => this.cleanParentReferences(value));
            }
        }
    }

    importSectionFromJson = (files: any, insertAfterSection: FormSections) => {
        if (!files.files || files.files.length === 0) {
            this.growl.show({ 
                severity: 'error', 
                summary: 'Import Failed', 
                detail: 'No file selected' 
            });
            return;
        }

        const file = files.files[0];
        if (!file.name.endsWith('.json')) {
            this.growl.show({ 
                severity: 'error', 
                summary: 'Import Failed', 
                detail: 'Please select a JSON file' 
            });
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const jsonContent = e.target?.result as string;
                const importedSection = parseJson(jsonContent, this.props.programContainer.CategoryId) as FormSections;
                
                if (!importedSection || !importedSection.ListOfFormSubSections) {
                    throw new Error('Invalid section format');
                }

                const formSectionsList = this.props.programContainer.ListOfFormSections;
                const maxId = formSectionsList.reduce((max, item) => {
                    return Math.max(max, parseInt(item.Id)) + 1;
                }, 1);
                
                const insertIndex = formSectionsList.findIndex(s => s.Id === insertAfterSection.Id);
                const newSequence = insertAfterSection.Sequence + 1;

                formSectionsList.forEach(section => {
                    if (section.Sequence >= newSequence) {
                        section.Sequence += 1;
                    }
                });

                importedSection.Id = maxId.toString();
                importedSection.Sequence = newSequence;
                importedSection.parent = this.props.programContainer;
                importedSection.ENUTitle = `${importedSection.ENUTitle || 'Imported Section'} (Copy)`;
                if (importedSection.FRATitle) {
                    importedSection.FRATitle = `${importedSection.FRATitle} (Copie)`;
                }

                importedSection.ListOfFormSubSections.forEach((subSection, subIndex) => {
                    subSection.parent = importedSection;
                    subSection.Sequence = subIndex + 1;
                    subSection.Id = subSection.Sequence.toString();
                    
                    if (subSection.ListOfFormSectionElements) {
                        subSection.ListOfFormSectionElements.forEach((element, elemIndex) => {
                            element.parent = subSection;
                            element.Sequence = elemIndex + 1;
                            element.Id = element.Sequence.toString();
                        });
                    }
                });

                formSectionsList.splice(insertIndex + 1, 0, importedSection);
                this.props.callback(this.props.programContainer);
                this.growl.show({ 
                    severity: 'success', 
                    summary: 'Import Successful', 
                    detail: `Section imported successfully as "${importedSection.ENUTitle}"` 
                });

                const sectionImportDialogVisible = [...this.state.sectionImportDialogVisible];
                sectionImportDialogVisible[insertAfterSection.Id] = false;
                this.setState({ sectionImportDialogVisible });

            } catch (error) {
                console.error('Error importing section:', error);
                this.growl.show({ 
                    severity: 'error', 
                    summary: 'Import Failed', 
                    detail: 'Failed to import section. Please check the JSON format.' 
                });
            }
        };

        reader.onerror = () => {
            this.growl.show({ 
                severity: 'error', 
                summary: 'Import Failed', 
                detail: 'Failed to read the file' 
            });
        };

        reader.readAsText(file);
    }

    render() {
        if (
            this.props.programContainer == null ||
            this.props.programContainer.ListOfFormSections == null
        )
            return null;
        return (
            <div>
                {/* @ts-ignore */}
                <Toast ref={(el) => this.growl = el} />
                {this.generateForm()}

                {/* @ts-ignore */}
                <ConfirmDialog
                    visible={this.state.confirmVisible}
                    onHide={() => this.setState({ confirmVisible: false })}
                    message="Are you sure you want to remove this?"
                    header="Confirmation"
                    icon="pi pi-exclamation-triangle"
                    accept={() => this.confirmRemove(true)}
                    reject={() => this.confirmRemove(false)}
                    closable={false}
                />
            </div>
        );
    }
}
